{
  "account.account": "Profil és biztonság",
  "account.accountDeleted": "Fiókját sikeresen töröltük.",
  "account.accountDescription": "Név, jelszó, fiók törlése",
  "account.accountSection": "Fiók",
  "account.changeEmail": "E-mail módosítása",
  "account.changePassword": "Jelszó módosítása",
  "account.currentPassword": "Jelenlegi jelszó",
  "account.dangerZone": "Veszélyzóna",
  "account.deleteAccount": "Fiók törlése",
  "account.deleteAccountConfirmation": "Biztosan törölni szeretné fiókját? Ez a művelet visszafordíthatatlan.",
  "account.deleteAccountDescription": "Ez a művelet törli fiókját és minden adatát. Nincs visszaút.",
  "account.emailChange": "E-mail cím módosítása",
  "account.emailChangeConfirmation": "E-mail módosítás megerősítése",
  "account.emailChangeFailure": "Az e-mail módosítási link érvénytelen vagy lejárt.",
  "account.emailChangeIntro": "Adja meg új e-mail címét és jelenlegi jelszavát. Az új címre küldünk egy linket: az e-mail címe csak akkor változik meg, amikor megnyitja.",
  "account.emailChangeSuccess": "Az e-mail címe sikeresen megváltozott erre: {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Az e-mail címe sikeresen megváltozott.",
  "account.emailChangeVerificationSent": "Egy megerősítő e-mailt küldtünk az új e-mail címére. Kérjük, ellenőrizze a bejövő leveleket, és kattintson a linkre a módosítás megerősítéséhez.",
  "account.manageAccount": "Fiók kezelése",
  "account.newEmailAddress": "Új e-mail cím",
  "account.newPassword": "Új jelszó",
  "account.newPasswordAgain": "Új jelszó megerősítése",
  "account.oldPassword": "Régi jelszó",
  "account.passwordChange": "Jelszó módosítása",
  "account.passwordChangeDescription": "Tartsa biztonságban a fiókját",
  "account.passwordUpdated": "A jelszó sikeresen frissítve.",
  "account.profile": "Profil",
  "account.profileUpdated": "A profil sikeresen frissítve.",
  "account.signedInAs": "Bejelentkezve mint",
  "account.updateYourProfile": "Adatok frissítése",
  "account.updateYourProfileDescription": "Név és megjelenítési beállítások",
  "addons.accountOnHold": "A fiókkapcsolat lejárt. Kérjük, csatlakozzon újra az adatfrissítések folytatásához.",
  "addons.accountOnHoldTitle": "Fiók felfüggesztve",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Hozzon létre és kérjen le API-kulcsot erről a linkről",
  "addons.ambientWeatherDescription": "Ambient Weather időjárás-állomások (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API kulcs",
  "addons.applicationKey": "Alkalmazáskulcs",
  "addons.availableServices": "Elérhető",
  "addons.cannotDisconnectLastAccount": "Nem lehet leválasztani az egyetlen bejelentkezési módszert. Kérjük, először adjon hozzá egy másik bejelentkezési módszert.",
  "addons.connect": "Csatlakoztatás",
  "addons.connected": "Csatlakoztatva",
  "addons.connectedAccounts": "Csatlakoztatott fiókok",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "Csatlakoztatott fiókok betöltése…",
  "addons.connectedServices": "Csatlakoztatva",
  "addons.connectedSince": "Csatlakoztatva {date} óta",
  "addons.connectionSection": "Kapcsolat",
  "addons.connectionSuccess": "{provider} fiók sikeresen csatlakoztatva",
  "addons.davisApiSecret": "API titkos kulcs",
  "addons.davisApiV2Key": "API-kulcs V2",
  "addons.davisDescription": "Davis meteorológiai állomások (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Töltse le a V2 API-kulcsokat erről a linkről",
  "addons.disconnect": "Leválasztás",
  "addons.disconnectConfirmation": "Biztosan le szeretné választani {provider} fiókját?",
  "addons.disconnectEnergyConfirmation": "A SmartMixin leállítja a Netatmo Energy szinkronizálását, és eltávolítja az otthonait a SmartMixinből. Netatmo-fiókját és eszközeit ez nem érinti.",
  "addons.disconnectEnergyDescription": "Leállítja a szinkronizálást, és eltávolítja az otthonait a SmartMixinből.",
  "addons.disconnectionSuccess": "{provider} fiók sikeresen leválasztva",
  "addons.disconnectProviderDescription": "Leállítja a szinkronizálást, és törli a szolgáltatás állomásait az előzményeikkel együtt.",
  "addons.disconnectServiceConfirmation": "A SmartMixin leállítja a(z) {provider} szinkronizálását, és törli a szolgáltatás állomásait a teljes előzményeikkel együtt. Magát a(z) {provider}-fiókját ez nem érinti.",
  "addons.disconnectServiceTitle": "{provider} leválasztása?",
  "addons.ecowittCreateAndRetrieveKeys": "Hozzon létre és kérjen le API-kulcsot és alkalmazáskulcsot erről a linkről",
  "addons.ecowittDescription": "Az Ecowitt professzionális meteorológiai állomásokat, vezeték nélküli beltéri/kültéri hőmérőket, nagy pontosságú esőmérőket, levegőminőség-érzékelőket és még sok mást kínál.",
  "addons.helpLink": "A(z) {provider} csatlakoztatása",
  "addons.integrationsSection": "Integrációk",
  "addons.myAcuriteAccountOnHold": "Fiókját felfüggesztettük. Kérjük, adja meg jelszavát a fiók újracsatlakozásához",
  "addons.myAcuriteDescription": "Az AcuRite az első számú meteorológiai állomás márka Észak-Amerikában. Az idő-, hőmérséklet- és időjárástechnológiában vezető szerepet betöltő AcuRite részletes információkat nyújt bel- és kültéri környezetéről, így magabiztosan tervezheti a napját.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "A Netatmo Thermostat segítségével akár a világ másik feléről is szabályozhatja otthona fűtését.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Az Ön személyes otthoni időjárás-állomása",
  "addons.notConnected": "Nincs csatlakoztatva",
  "addons.or": "vagy",
  "addons.providerAccountDisconnected": "Az időjárás-szolgáltatáshoz való kapcsolat lejárt. Kérjük, csatlakozzon újra az adatfrissítések folytatásához.",
  "addons.reconnect": "Újracsatlakoztatás",
  "addons.socialConnectionsIntro": "Csatlakoztassa közösségi fiókjait a gyors bejelentkezéshez. Bármikor csatlakoztathatja vagy leválaszthatja a fiókokat.",
  "addons.weatherflowAccessToken": "Hozzáférési token",
  "addons.weatherflowCreateToken": "Hozza létre és kérje le a tokent erről a linkről",
  "addons.weatherflowTempestDescription": "Tempest időjárási rendszer beépített szélmérővel és esőmérővel",
  "addons.weatherServices": "Időjárási szolgáltatások",
  "addons.weatherServicesConnected": "{count, plural, =0 {Nincs csatlakoztatott szolgáltatás} one {# csatlakoztatott szolgáltatás} other {# csatlakoztatott szolgáltatás}}",
  "addons.weatherServicesDescription": "Csatlakoztassa a Netatmo, Davis, Weatherflow és más eszközöket",
  "addons.wundergroundApiKey": "API kulcs",
  "addons.wundergroundDescription": "A Weather Underground egy olyan emberek globális közössége, akik környezeti érzékelőktől, például időjárás-állomásoktól és levegőminőség-figyelőktől származó adatokat kapcsolnak össze, hogy gazdag, hiperlokális adatokat szállíthassunk, amelyekre szüksége van szenvedélyeinek táplálásához.",
  "addons.wundergroundRemoveStationDescription": "Az állomás kikerül a SmartMixin-fiókjából. Hacsak egy másik SmartMixin-fiók is hozzá nem adta, az állomás és a SmartMixin által róla rögzített előzmények törlődnek. A Weather Undergroundon semmi sem változik.",
  "addons.wundergroundRemoveStationTitle": "Törli ezt: {station}?",
  "addons.wundergroundRetrieveApiKey": "Töltse le az API-kulcsot erről a linkről",
  "addons.wundergroundStationId": "Állomásazonosító",
  "airQuality.adviceActivityGood": "Ideális nap a szabadtéri mozgáshoz",
  "airQuality.adviceActivityHazardous": "Kerüljön minden szabadtéri fizikai tevékenységet",
  "airQuality.adviceActivityLabel": "Fizikai aktivitás",
  "airQuality.adviceActivityModerate": "Jó nap a szabadtéri mozgáshoz",
  "airQuality.adviceActivitySensitive": "Fontolja meg a rövidebb és kevésbé intenzív szabadtéri tevékenységet",
  "airQuality.adviceActivityUnhealthy": "Csökkentse a hosszú vagy intenzív tevékenységeket, és tartson több szünetet",
  "airQuality.adviceActivityVeryUnhealthy": "Kerülje a hosszú vagy intenzív tevékenységeket; fontolja meg a beltérbe helyezésüket",
  "airQuality.adviceGroupsGood": "Nincs szükség különleges óvintézkedésre",
  "airQuality.adviceGroupsHazardous": "Maradjon beltérben, és tartsa alacsonyan az aktivitást",
  "airQuality.adviceGroupsLabel": "Érzékeny csoportok",
  "airQuality.adviceGroupsModerate": "Különösen érzékeny személyek: rövidebb és kevésbé intenzív tevékenység",
  "airQuality.adviceGroupsSensitive": "Rövidebb és kevésbé intenzív szabadtéri tevékenység, több szünettel",
  "airQuality.adviceGroupsUnhealthy": "Kerülje a hosszú vagy intenzív szabadtéri tevékenységeket; fontolja meg a beltérbe helyezésüket",
  "airQuality.adviceGroupsVeryUnhealthy": "Kerüljön minden szabadtéri fizikai tevékenységet; halassza el vagy helyezze beltérbe",
  "airQuality.adviceTimingLabel": "Mikor menjen ki",
  "airQuality.adviceTimingMorning": "Lehetőleg délelőtt — ilyenkor alacsonyabb az ózonszint",
  "airQuality.airQuality": "Levegő minősége",
  "airQuality.airQualityIndex": "Levegőminőségi index",
  "airQuality.aqiForecast": "Levegőminőség-előrejelzés",
  "airQuality.co2Fresh": "Friss",
  "airQuality.co2GettingStale": "Kissé fülledt",
  "airQuality.co2Stale": "Fülledt",
  "airQuality.dailyForecast": "Napi előrejelzés",
  "airQuality.dominantPollutant": "Domináns szennyező anyag",
  "airQuality.expectedPeak": "Várható csúcs",
  "airQuality.good": "Jó",
  "airQuality.goodDescription": "A levegő minősége kielégítőnek tekinthető, és a légszennyezés csekély vagy egyáltalán nem jelent kockázatot.",
  "airQuality.hazardous": "Veszélyes",
  "airQuality.hazardousDescription": "Egészségügyi figyelmeztetés: Bárki tapasztalhat komolyabb egészségügyi hatásokat.",
  "airQuality.indoorAirQuality": "Beltéri levegő minősége",
  "airQuality.moderate": "Mérsékelt",
  "airQuality.moderateDescription": "A levegő minősége elfogadható. Egyes szennyező anyagok azonban egészségügyi kockázatot jelenthetnek nagyon kis számú, a levegőszennyezésre szokatlanul érzékeny ember számára.",
  "airQuality.noForecastForLocation": "Ehhez a helyhez nem érhető el levegőminőségi előrejelzés.",
  "airQuality.now": "Most",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Szennyezőanyagok",
  "airQuality.recommendations": "Ajánlások",
  "airQuality.sensitiveUnhealthy": "Rossz az érzékeny csoportoknak",
  "airQuality.sensitiveUnhealthyDescription": "Az érzékeny csoportok tagjainál egészségügyi hatások jelentkezhetnek. A lakosság többségét valószínűleg nem érinti.",
  "airQuality.subIndex": "AQI részindex",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Az index értelmezése",
  "airQuality.unhealthy": "Rossz",
  "airQuality.unhealthyDescription": "Bárki érezheti az egészségügyi hatásokat; az érzékeny csoportok tagjai súlyosabb egészségügyi hatásokat tapasztalhatnak.",
  "airQuality.veryUnhealthy": "Nagyon rossz",
  "airQuality.veryUnhealthyDescription": "Egészségügyi figyelmeztetések vészhelyzetekre. Valószínűbb, hogy az egész lakosságot érinti.",
  "alerts.addAlert": "Figyelmeztetés hozzáadása",
  "alerts.addCondition": "Feltétel hozzáadása",
  "alerts.alertAdded": "A figyelmeztetés sikeresen hozzáadva",
  "alerts.alertAuthorizationNotice": "A riasztások csak akkor működnek, ha engedélyezi a SmartMixin számára az értesítések megjelenítését",
  "alerts.alertDeleted": "A figyelmeztetés sikeresen törölve",
  "alerts.alertName": "Figyelmeztetés neve",
  "alerts.alertWhen": "Riasztást kérek, ha:",
  "alerts.aqiGreaterThan": "AQI nagyobb, mint",
  "alerts.aqiGreaterThanThreshold": "Az AQI {value}{unit} küszöbérték felett van",
  "alerts.aqiLessThan": "AQI kevesebb, mint",
  "alerts.aqiLessThanThreshold": "Az AQI {value}{unit} küszöb alatt van",
  "alerts.atLeastOneCondition": "Legalább egy feltételt hozzá kell adni",
  "alerts.co2GreaterThan": "CO2 nagyobb, mint",
  "alerts.co2GreaterThanThreshold": "CO2 a(z) {value}{unit} küszöbérték felett",
  "alerts.co2LessThan": "CO2 kevesebb, mint",
  "alerts.co2LessThanThreshold": "CO2 a(z) {value}{unit} küszöb alatt",
  "alerts.conditions": "Feltételek",
  "alerts.conditionsDroppedOnStationChange": "Ez az állomás nem támogatja, eltávolítva: {conditions}",
  "alerts.createAlert": "Figyelmeztetés létrehozása",
  "alerts.dailyPrecipitationGreaterThan": "Napi csapadék nagyobb, mint",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Napi csapadék meghaladja a {value}{unit} küszöbértéket",
  "alerts.deleteAlert": "Figyelmeztetés törlése",
  "alerts.editAlert": "Figyelmeztetés szerkesztése",
  "alerts.editCondition": "Feltétel módosítása",
  "alerts.gustSpeedGreaterThan": "A széllökés nagyobb, mint",
  "alerts.gustSpeedGreaterThanThreshold": "A széllökés meghaladja a {value}{unit} küszöbértéket",
  "alerts.gustSpeedLessThan": "A széllökések kisebbek, mint",
  "alerts.gustSpeedLessThanThreshold": "A széllökés {value}{unit} küszöb alatt van",
  "alerts.heatIndexGreaterThan": "Hőindex több, mint",
  "alerts.heatIndexGreaterThanThreshold": "A Hőindex meghaladja a {value}{unit} küszöbértéket",
  "alerts.heatIndexLessThan": "Hőindex kevesebb, mint",
  "alerts.heatIndexLessThanThreshold": "A Hőindex {value}{unit} küszöb alatt van",
  "alerts.humidexGreaterThan": "Humidex több, mint",
  "alerts.humidexGreaterThanThreshold": "A Humidex meghaladja a {value}{unit} küszöbértéket",
  "alerts.humidexLessThan": "Humidex kevesebb, mint",
  "alerts.humidexLessThanThreshold": "A Humidex {value}{unit} küszöb alatt van",
  "alerts.humidityGreaterThan": "Páratartalom nagyobb, mint",
  "alerts.humidityGreaterThanThreshold": "A páratartalom meghaladja a {value}{unit} küszöbértéket",
  "alerts.humidityLessThan": "Páratartalom kisebb, mint",
  "alerts.humidityLessThanThreshold": "A páratartalom {value}{unit} küszöb alatt van",
  "alerts.inProgress": "Folyamatban",
  "alerts.leafWetnessGreaterThan": "Levélnedvesség nagyobb, mint",
  "alerts.leafWetnessGreaterThanThreshold": "A levélnedvesség meghaladja a {value}{unit} küszöbértéket",
  "alerts.leafWetnessLessThan": "Levélnedvesség kisebb, mint",
  "alerts.leafWetnessLessThanThreshold": "A levélnedvesség {value}{unit} küszöb alatt van",
  "alerts.myAlerts": "Saját figyelmeztetéseim",
  "alerts.noConfiguredAlert": "Még nincs figyelmeztetése, adjon hozzá egyet",
  "alerts.noiseGreaterThan": "Zaj nagyobb, mint",
  "alerts.noiseGreaterThanThreshold": "Zaj meghaladja a(z) {value}{unit} küszöbértéket",
  "alerts.noiseLessThan": "Zaj kisebb, mint",
  "alerts.noiseLessThanThreshold": "Zaj {value}{unit} küszöb alatt",
  "alerts.noteOnConditions": "Vegye figyelembe, hogy a riasztás akkor aktiválódik, ha az alábbi feltételek mindegyike érvényesül",
  "alerts.noTriggerHistory": "Ez a riasztás még nem aktiválódott.",
  "alerts.pm10GreaterThan": "PM 10 nagyobb, mint",
  "alerts.pm10GreaterThanThreshold": "PM 10 {value}{unit} küszöbérték felett",
  "alerts.pm10LessThan": "PM 10 kevesebb mint",
  "alerts.pm10LessThanThreshold": "PM 10 {value}{unit} küszöb alatt van",
  "alerts.pm1GreaterThan": "PM 1 nagyobb, mint",
  "alerts.pm1GreaterThanThreshold": "PM 1 a {value}{unit} küszöbérték felett",
  "alerts.pm1LessThan": "PM 1 kevesebb mint",
  "alerts.pm1LessThanThreshold": "PM 1 a {value}{unit} küszöb alatt van",
  "alerts.pm2p5GreaterThan": "PM 2,5 nagyobb, mint",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 a {value}{unit} küszöbérték felett",
  "alerts.pm2p5LessThan": "PM 2,5 kevesebb, mint",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 a {value}{unit} küszöb alatt",
  "alerts.postStormSummary": "Esőzés összegzése",
  "alerts.postStormSynopsisHelper": "Minden esőzés végén összegző értesítést kap.",
  "alerts.postStormSynopsisSoleCondition": "Az esőzés összegzése nem kombinálható más feltételekkel.",
  "alerts.precipitationGreaterThan": "Óránkénti csapadék nagyobb, mint",
  "alerts.precipitationGreaterThanThreshold": "Óránkénti csapadék meghaladja a {value}{unit} küszöbértéket",
  "alerts.pressureGreaterThan": "Nyomás nagyobb, mint",
  "alerts.pressureGreaterThanThreshold": "Nyomás a(z) {value}{unit} küszöbérték felett",
  "alerts.pressureLessThan": "Nyomás kisebb, mint",
  "alerts.pressureLessThanThreshold": "A nyomás {value}{unit} küszöb alatt van",
  "alerts.rainRateGreaterThan": "Eső intenzitása nagyobb, mint",
  "alerts.rainRateGreaterThanThreshold": "Eső intenzitása meghaladja a {value}{unit} küszöbértéket",
  "alerts.sensorNotReporting": "Ez az érzékelő jelenleg nem küld adatot. A figyelmeztetés akkor folytatódik, amikor újra küld.",
  "alerts.soilMoistureGreaterThan": "Talajnedvesség nagyobb, mint",
  "alerts.soilMoistureGreaterThanThreshold": "A talajnedvesség meghaladja a {value}{unit} küszöbértéket",
  "alerts.soilMoistureLessThan": "Talajnedvesség kisebb, mint",
  "alerts.soilMoistureLessThanThreshold": "A talajnedvesség {value}{unit} küszöb alatt van",
  "alerts.solarRadiationGreaterThan": "A napsugárzás nagyobb, mint",
  "alerts.solarRadiationGreaterThanThreshold": "A napsugárzás meghaladja a {value}{unit} küszöbértéket",
  "alerts.solarRadiationLessThan": "A napsugárzás kevesebb, mint",
  "alerts.solarRadiationLessThanThreshold": "A napsugárzás {value}{unit} küszöbérték alatt van",
  "alerts.stationNoLongerReports": "Ez az állomás már nem küld adatokat, ezért ez a figyelmeztetés nem aktiválódhat.",
  "alerts.stormChartUnavailable": "Ehhez az esőzéshez nem érhető el csapadéktörténet.",
  "alerts.stormDetail": "Esőzés összegzése",
  "alerts.stormDuration": "Időtartam",
  "alerts.stormEnd": "Vége",
  "alerts.stormPeakRate": "Legnagyobb esőintenzitás",
  "alerts.stormStart": "Kezdet",
  "alerts.stormTotal": "Összes csapadék",
  "alerts.temperatureGreaterThan": "Hőmérséklet nagyobb, mint",
  "alerts.temperatureGreaterThanThreshold": "A hőmérséklet meghaladja a {value}{unit} küszöbértéket",
  "alerts.temperatureLessThan": "Hőmérséklet kisebb, mint",
  "alerts.temperatureLessThanThreshold": "A hőmérséklet {value}{unit} küszöb alatt van",
  "alerts.thresholdOutOfRange": "{min} és {max} között kell lennie",
  "alerts.thswGreaterThan": "THSW több, mint",
  "alerts.thswGreaterThanThreshold": "A THSW meghaladja a {value}{unit} küszöbértéket",
  "alerts.thswLessThan": "THSW kevesebb, mint",
  "alerts.thswLessThanThreshold": "A THSW {value}{unit} küszöb alatt van",
  "alerts.thwGreaterThan": "THW több, mint",
  "alerts.thwGreaterThanThreshold": "A THW meghaladja a {value}{unit} küszöbértéket",
  "alerts.thwLessThan": "THW kevesebb, mint",
  "alerts.thwLessThanThreshold": "A THW {value}{unit} küszöb alatt van",
  "alerts.triggerHistory": "Riasztási előzmények",
  "alerts.uvGreaterThan": "UV nagyobb, mint",
  "alerts.uvGreaterThanThreshold": "UV a {value}{unit} küszöbérték felett",
  "alerts.uvLessThan": "UV alacsonyabb, mint",
  "alerts.uvLessThanThreshold": "UV a {value}{unit} küszöb alatt",
  "alerts.visibilityGreaterThanThreshold": "A láthatóság meghaladja a {value}{unit} küszöbértéket",
  "alerts.visibilityLessThanThreshold": "A láthatóság {value}{unit} küszöb alatt van",
  "alerts.visiblityGreaterThan": "Láthatóság nagyobb, mint",
  "alerts.visiblityLessThan": "Láthatóság kisebb, mint",
  "alerts.whichMeasure": "Melyik mérésre szeretne figyelmeztetést kapni?",
  "alerts.whichModule": "Melyik modulra szeretne figyelmeztetést kapni?",
  "alerts.whichSensor": "Melyik érzékelőre szeretne figyelmeztetést kapni?",
  "alerts.windChillGreaterThan": "Szélhűtés több, mint",
  "alerts.windChillGreaterThanThreshold": "A Szélhűtés meghaladja a {value}{unit} küszöbértéket",
  "alerts.windChillLessThan": "Szélhűtés kevesebb, mint",
  "alerts.windChillLessThanThreshold": "A Szélhűtés {value}{unit} küszöb alatt van",
  "alerts.windSpeedGreaterThan": "A szél nagyobb mint",
  "alerts.windSpeedGreaterThanThreshold": "Szél {value}{unit} küszöb felett",
  "alerts.windSpeedLessThan": "A szél kisebb, mint",
  "alerts.windSpeedLessThanThreshold": "A szél {value}{unit} küszöb alatt van",
  "appUpdate.updateAvailable": "Frissítés érhető el",
  "appUpdate.updateAvailableOpenAppStore": "Koppintson az App Store megnyitásához",
  "appUpdate.updateAvailableOpenGooglePlay": "Koppintson a Google Play megnyitásához",
  "appUpdate.updateAvailableVersion": "Frissítés érhető el: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Az alkalmazás frissítésére van szükség. Látogasson el a Google Playre a frissítéshez.",
  "appUpdate.upgradeRequiredIos": "Az alkalmazás frissítésére van szükség. Látogasson el az App Store-ba a frissítéshez.",
  "astral.aboveHorizonAllDay": "Egész nap a horizont felett",
  "astral.aboveTheHorizon": "a horizont felett",
  "astral.apparentSize": "Látszó méret",
  "astral.apparentSizeAcross": "{size} átmérő",
  "astral.astronomicalDawn": "Csillagászati hajnal",
  "astral.astronomicalDusk": "Csillagászati alkony",
  "astral.belowHorizonAllDay": "Egész nap a horizont alatt",
  "astral.belowHorizonSince": "{time} óta a horizont alatt",
  "astral.belowHorizonSinceOn": "{day} {time} óta a horizont alatt",
  "astral.brightAllNight": "Egész éjjel világos — soha nem lesz teljesen sötét",
  "astral.brightestMoment": "Legvilágosabb pillanat",
  "astral.civilDawn": "Polgári hajnal",
  "astral.civilDusk": "Polgári alkony",
  "astral.darkSkyBetween": "Sötét égbolt {from} → {to}",
  "astral.darkSkyWindow": "Sötét égbolt {from} → {to} · {duration} Hold nélkül",
  "astral.dayLength": "Nappal hossza",
  "astral.daylightThroughTheYear": "Nappalhossz az év során",
  "astral.dayOfCycle": "{total} napból {day}",
  "astral.doesNotOccurToday": "Ma nem következik be",
  "astral.domeHint": "Húzd végig az éjszakán",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Legkorábbi napkelte",
  "astral.earliestSunset": "Legkorábbi napnyugta",
  "astral.equinox": "Napéjegyenlőség",
  "astral.equinoxIn": "Napéjegyenlőség {days} nap múlva",
  "astral.evening": "Este",
  "astral.exactPhaseAt": "Pontosan {time}-kor",
  "astral.firstQuarter": "Első negyed",
  "astral.firstSunriseIn": "Első napkelte {days} nap múlva",
  "astral.firstSunsetIn": "Első napnyugta {days} nap múlva",
  "astral.fullMoon": "Telihold",
  "astral.goldenHourBegins": "Aranyóra kezdete",
  "astral.goldenHourEnds": "Aranyóra vége",
  "astral.highestPoint": "Legmagasabb pont",
  "astral.inDays": "{days} nap múlva",
  "astral.lastQuarter": "Utolsó negyed",
  "astral.latestSunrise": "Legkésőbbi napkelte",
  "astral.latestSunset": "Legkésőbbi napnyugta",
  "astral.litShort": "Megvil.",
  "astral.longestDay": "Leghosszabb nap",
  "astral.lowestPoint": "Legalacsonyabb pont",
  "astral.maxAltitudeShort": "Max.",
  "astral.midday": "Dél",
  "astral.midnightSun": "Éjféli nap",
  "astral.midnightSunPeriod": "Éjféli nap",
  "astral.milestoneFootnotePolar": "Itt a nap az év {days, plural, one {# napján} other {# napján}} sem kel fel, sem nem nyugszik le, így a lista a szokásos napkelte- és napnyugta-szélsőértékek helyett azt mutatja, mikor történik ez.",
  "astral.milestoneFootnoteTemperate": "A legkorábbi naplemente és a legkésőbbi napkelte nem a legrövidebb napra esik — ezt a két dátumot az időegyenlet határozza meg, nem a napforduló.",
  "astral.moon": "Hold",
  "astral.moonAltitude": "Magasság",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Távolság",
  "astral.moonlessFor": "{duration} Hold nélkül",
  "astral.moonPhases": "Holdfázisok",
  "astral.moonrise": "Holdkelte",
  "astral.moonset": "Holdnyugta",
  "astral.moonUpAllNight": "A Hold egész éjjel a horizont felett van",
  "astral.moonWashesOutNight": "A Hold {rise} és {set} között a horizont felett van, és bevilágítja az egész éjszakát",
  "astral.morning": "Reggel",
  "astral.nauticalDawn": "Navigációs hajnal",
  "astral.nauticalDusk": "Navigációs alkony",
  "astral.newMoon": "Újhold",
  "astral.nextDay": "+1 nap",
  "astral.nextProperlyDarkNight": "Következő igazán sötét éjszaka",
  "astral.nextRise": "következő holdkelte: {time}",
  "astral.nextRiseOn": "következő holdkelte: {day} {time}",
  "astral.nextSevenNights": "A következő hét éjszaka",
  "astral.nightDate": "Dátum",
  "astral.noAstronomicalDarknessTonight": "Ma éjjel nincs csillagászati sötétség",
  "astral.noDarkNightAhead": "Nincs a következő két hétben",
  "astral.noStationLocation": "Ismeretlen hely",
  "astral.noStationLocationDescription": "Ennek az állomásnak nincs rögzített helyzete, ezért a Nap és a Hold nem számítható ki hozzá.",
  "astral.noSunriseToday": "Ma nincs napkelte",
  "astral.nowAtBearing": "most {altitude} · azimut {direction}",
  "astral.observing": "Észlelés",
  "astral.ofDaylightLeft": "napfény van hátra",
  "astral.overTheNextThreeWeeks": "a következő 3 hétben",
  "astral.percentLit": "{percent} megvilágítva",
  "astral.polarNight": "Sarki éjszaka",
  "astral.polarNightPeriod": "Sarki éjszaka",
  "astral.rightNow": "Most",
  "astral.riseShort": "Kelte",
  "astral.setShort": "Nyugta",
  "astral.shortestDay": "Legrövidebb nap",
  "astral.solarNoon": "Valódi dél",
  "astral.solstice": "Napforduló",
  "astral.sunBelowHorizon": "A Nap {degrees}°-kal a horizont alatt",
  "astral.sunEvents": "Napesemények",
  "astral.sunNeverDarkEnough": "A Nap sosem süllyed 18°-kal a horizont alá",
  "astral.sunNeverSets": "A Nap nem nyugszik le",
  "astral.sunrise": "Napkelte",
  "astral.sunriseAndSunset": "Napkelte és napnyugta",
  "astral.sunriseAt": "Napkelte: {time}",
  "astral.sunset": "Napnyugta",
  "astral.sunsetAt": "Napnyugta: {time}",
  "astral.thisYearAtNorth": "Idén {degrees}° északi szélességen",
  "astral.thisYearAtSouth": "Idén {degrees}° déli szélességen",
  "astral.tonight": "Ma éjjel",
  "astral.twilightAllNight": "Egész éjjel szürkület — soha nem lesz teljesen sötét",
  "astral.upFor": "{duration} a horizont felett",
  "astral.usableLight": "Használható fény",
  "astral.vsAverage": "{percent} az átlaghoz képest",
  "astral.vsYesterday": "tegnaphoz képest",
  "astral.waningCrescent": "Fogyó holdsarló",
  "astral.waningGibbous": "Fogyó púpos hold",
  "astral.waxingCrescent": "Növekvő holdsarló",
  "astral.waxingGibbous": "Növekvő púpos hold",
  "astral.whereToLook": "Merre nézz",
  "astral.withoutTheMoon": "{duration} Hold nélkül",
  "auth.alreadyHaveAccount": "Már van fiókja?",
  "auth.authContainerTagline": "Személyes időjárás műszerfal. Csatlakoztassa állomásait, és valós idejű adatokat kapjon kéznél.",
  "auth.backToLogin": "Vissza a bejelentkezéshez",
  "auth.checkYourEmail": "Ellenőrizze e-mailjét",
  "auth.continueWithApple": "Folytatás Apple-lel",
  "auth.continueWithFacebook": "Folytatás Facebook-kal",
  "auth.continueWithGoogle": "Folytatás Google-lel",
  "auth.email": "E-mail cím",
  "auth.emailRequiredLoginFacebook": "Email jóváhagyás szükséges a Facebook-bejelentkezéshez",
  "auth.emailVerification": "E-mail-cím megerősítése",
  "auth.emailVerificationFailure": "Hiba történt az e-mail-cím ellenőrzése során.",
  "auth.emailVerificationSuccess": "E-mail-címét sikeresen ellenőriztük.",
  "auth.firstName": "Keresztnév",
  "auth.forgotPassword": "Elfelejtett jelszó",
  "auth.forgotPasswordSubtitle": "Adja meg e-mail címét, és küldünk egy linket a jelszó visszaállításához.",
  "auth.lastName": "Vezetéknév",
  "auth.login": "Bejelentkezés",
  "auth.loginSubtitle": "Üdvözöljük újra! Kérjük, adja meg adatait.",
  "auth.loginToSmartMixinDescription": "Jelentkezzen be a SmartMixinbe, hogy elérje időjárás-állomásait, megtekintse az elemzéseket és kezelje személyes időjárás-műszerfalát.",
  "auth.logout": "Kijelentkezés",
  "auth.logoutConfirmation": "Ki szeretne jelentkezni?",
  "auth.noAccountYet": "Még nincs fiókja?",
  "auth.or": "vagy",
  "auth.password": "Jelszó",
  "auth.passwordReset": "Jelszó visszaállítása",
  "auth.passwordResetSuccess": "Sikeres jelszó-visszaállítás.",
  "auth.register": "Regisztráció",
  "auth.registerDescription": "Hozzon létre ingyenes SmartMixin fiókot az időjárás-állomások csatlakoztatásához, időjárási adatok nyomon követéséhez és hatékony elemzési eszközök eléréséhez.",
  "auth.registerSubtitle": "Hozza létre fiókját a kezdéshez.",
  "auth.restorePassword": "Jelszó visszaállítása",
  "auth.restorePasswordSuccess": "Küldtünk egy linket a jelszó visszaállításához a(z) {emailAddress} címre a további utasításokkal.",
  "auth.sendReset": "Helyreállítási adatok küldése",
  "auth.signInWithApple": "Bejelentkezés az Apple-lel",
  "auth.socialAccount": "vagy használja valamelyik közösségi profilját",
  "auth.staffVerificationCode": "Ellenőrző kód",
  "auth.staffVerificationExpiresIn": "Ellenőrizve. {duration} múlva lejár.",
  "auth.staffVerificationInvalidCode": "Hibás kód. Próbálja újra.",
  "auth.staffVerificationLoginAsStopped": "A Login As leállt: a folytatáshoz adjon meg egy ellenőrző kódot a Debug képernyőn.",
  "auth.staffVerificationNotEnrolled": "A fiókjához nincs beállítva hitelesítő alkalmazás. Adjon hozzá egyet a háttériroda biztonsági beállításaiban.",
  "auth.staffVerificationPasskey": "Ellenőrzés azonosítókulccsal",
  "auth.staffVerificationPasskeyExpired": "Az azonosítókulcs-kérés lejárt. Próbálja újra.",
  "auth.staffVerificationPasskeyFailed": "Az azonosítókulcsos ellenőrzés sikertelen. Próbálja újra, vagy adjon meg egy kódot.",
  "auth.staffVerificationPasskeyNotEnrolled": "Ezen a telefonon nincs elérhető azonosítókulcs a fiókjához. Adjon hozzá egyet erről a telefonról a háttériroda biztonsági beállításaiban, vagy adjon meg egy kódot.",
  "auth.staffVerificationPasskeySetupLink": "Azonosítókulcs hozzáadása",
  "auth.staffVerificationPasskeyUnavailable": "Itt nem használhatók azonosítókulcsok. Adjon meg helyette egy kódot.",
  "auth.staffVerificationPrompt": "A Login As és a felhasználókeresés használatához adja meg a hitelesítő alkalmazás 6 jegyű kódját vagy egy helyreállítási kódot.",
  "auth.staffVerificationPromptPasskey": "A Login As és a felhasználókeresés eléréséhez használja az azonosítókulcsát, vagy adja meg a hitelesítő alkalmazás 6 jegyű kódját vagy egy helyreállítási kódot.",
  "auth.staffVerificationSetupLink": "Hitelesítő alkalmazás hozzáadása",
  "auth.staffVerificationSubmit": "Ellenőrzés",
  "auth.staffVerificationTitle": "Munkatársi ellenőrzés",
  "calendar.afternoon": "Délután",
  "calendar.april": "Április",
  "calendar.august": "Augusztus",
  "calendar.changePeriod": "Időszak: {period}. Időszak módosítása",
  "calendar.currentDay": "Ma",
  "calendar.dateFormat": "Dátumformátum",
  "calendar.day": "Nap",
  "calendar.december": "December",
  "calendar.durationHours": "{hours} ó",
  "calendar.durationHoursMinutes": "{hours} ó {minutes} p",
  "calendar.durationMinutes": "{minutes} p",
  "calendar.durationMinutesSeconds": "{minutes} p {seconds} mp",
  "calendar.durationSeconds": "{seconds} mp",
  "calendar.earlierYears": "Korábbi évek",
  "calendar.endTime": "Vége",
  "calendar.evening": "Este",
  "calendar.february": "Február",
  "calendar.goToNextDay": "Következő nap",
  "calendar.goToNextMonth": "Következő hónap",
  "calendar.goToNextWeek": "Következő hét",
  "calendar.goToNextYear": "Következő év",
  "calendar.goToPreviousDay": "Előző nap",
  "calendar.goToPreviousMonth": "Előző hónap",
  "calendar.goToPreviousWeek": "Előző hét",
  "calendar.goToPreviousYear": "Előző év",
  "calendar.hour": "Óra",
  "calendar.hoursCount": "{count, plural, one {# óra} other {# óra}}",
  "calendar.hoursShort": "ó",
  "calendar.hoursShortCount": "{count, plural, one {# ó} other {# ó}}",
  "calendar.january": "Január",
  "calendar.july": "Július",
  "calendar.june": "Június",
  "calendar.last12Hours": "Utolsó 12 óra",
  "calendar.last24Hours": "Elmúlt 24 óra",
  "calendar.last30Days": "Elmúlt 30 nap",
  "calendar.last3Hours": "Utolsó 3 óra",
  "calendar.last6Hours": "Utolsó 6 óra",
  "calendar.last7Days": "Elmúlt 7 nap",
  "calendar.lastHour": "Utolsó óra",
  "calendar.laterYears": "Későbbi évek",
  "calendar.march": "Március",
  "calendar.max": "Max",
  "calendar.may": "Május",
  "calendar.month": "Hónap",
  "calendar.monthTotal": "Ebben a hónapban",
  "calendar.morning": "Reggel",
  "calendar.nextHours": "Következő órák",
  "calendar.night": "Éjszaka",
  "calendar.november": "November",
  "calendar.october": "Október",
  "calendar.oneDay": "1 nap",
  "calendar.oneHour": "1 óra",
  "calendar.oneMonth": "1 hónap",
  "calendar.oneWeek": "1 hét",
  "calendar.periodRangeSpoken": "{start} és {end} között",
  "calendar.previous24Hours": "Az előző 24 óra",
  "calendar.previous30Days": "Az előző 30 nap",
  "calendar.previous7Days": "Az előző 7 nap",
  "calendar.previousDay": "Előző nappal",
  "calendar.previousHours": "Korábbi órák",
  "calendar.previousMonth": "Előző hónappal",
  "calendar.previousWeek": "Előző héttel",
  "calendar.previousYear": "Előző évvel",
  "calendar.sameDayLastYear": "Tavaly ugyanezzel a nappal",
  "calendar.sameMonthLastYear": "Tavaly ugyanezzel a hónappal",
  "calendar.selectADate": "Válasszon ki egy dátumot",
  "calendar.selectAggregation": "Megjelenített érték kiválasztása",
  "calendar.selectAMonth": "Válasszon egy hónapot",
  "calendar.selectAYear": "Válasszon egy évet",
  "calendar.selectGranularity": "Válasszon részletességet",
  "calendar.selectPeriod": "Válasszon ki egy időszakot",
  "calendar.september": "Szeptember",
  "calendar.sixHours": "6 óra",
  "calendar.startTime": "Kezdet",
  "calendar.thirtyMinutes": "30 perc",
  "calendar.threeHours": "3 óra",
  "calendar.timezone": "Időzóna",
  "calendar.today": "Ma",
  "calendar.untilChanged": "Módosításig",
  "calendar.untilTime": "Eddig: {time}",
  "calendar.untilTodayAt": "Ma {time}-ig",
  "calendar.untilTomorrowAt": "Holnap {time}-ig",
  "calendar.use24HourFormat": "24 órás formátum használata",
  "calendar.week": "Hét",
  "calendar.year": "Év",
  "calendar.yearToDate": "Idén",
  "calendar.yesterday": "Tegnap",
  "charts.averageOverThePeriod": "Időszakos átlag",
  "charts.calendarView": "Naptár nézet",
  "charts.charts": "Grafikonok",
  "charts.chartView": "Diagram nézet",
  "charts.comparison": "Összehasonlítás",
  "charts.customizeComparisonMetrics": "Összehasonlítási mutatók testreszabása",
  "charts.customizeComparisonMetricsDescription": "Húzza az elemeket az összehasonlítási mutatók átrendezéséhez. Koppintson a szem ikonra a mutatók megjelenítéséhez vagy elrejtéséhez.",
  "charts.loading": "Grafikon betöltése",
  "charts.maxOverThePeriod": "Időszakos maximum",
  "charts.measureToDisplay": "Megjelenítendő mérés",
  "charts.minMaxRange": "Min. / Max.",
  "charts.noDataForThisPeriod": "Nincs adat a választott időszakban",
  "charts.observations": "Észlelések",
  "charts.observedTemperature": "Mért hőmérséklet",
  "charts.seriesTableDate": "Dátum",
  "charts.showComparison": "Összehasonlítás megjelenítése",
  "charts.stationComparison": "Állomások összehasonlítása",
  "charts.stationComparisonDescription": "Lehetővé teszi a korábbi időjárási adatok összehasonlítását egy másik állomás adataival.",
  "charts.sumOverThePeriod": "Az időszakban összesen",
  "charts.tableLabel": "{chart} táblázat",
  "charts.toggleSeries": "{series} megjelenítése vagy elrejtése",
  "charts.viewAsChart": "Grafikon",
  "charts.viewAsList": "Lista",
  "charts.viewAsPeriods": "Napszakok",
  "charts.viewAsTable": "Táblázat",
  "charts.viewLabel": "{chart} nézet",
  "common.add": "Hozzáadás",
  "common.altitude": "Magasság",
  "common.analysis": "Elemzés",
  "common.average": "Átlag",
  "common.back": "Vissza",
  "common.backToHome": "Vissza a főoldalra",
  "common.cancel": "Mégse",
  "common.cannotBeEmpty": "Ez a mező nem lehet üres.",
  "common.close": "Bezárás",
  "common.dailyForecast": "Napi előrejelzés",
  "common.default": "Alapértelmezett",
  "common.delete": "Töröl",
  "common.details": "Részletek",
  "common.edit": "Szerkesztés",
  "common.exitFullscreen": "Kilépés a teljes képernyőből",
  "common.forecast": "Előrejelzés",
  "common.frequency": "Frekvencia",
  "common.full": "Teljes",
  "common.fullscreen": "Teljes képernyő",
  "common.help": "Súgó",
  "common.hidden": "Rejtett",
  "common.high": "Magas",
  "common.iDontKnowYet": "Még nem tudom",
  "common.indoor": "Beltér",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Utolsó frissítés",
  "common.low": "Alacsony",
  "common.maximum": "Maximum",
  "common.medium": "Közepes",
  "common.minimum": "Minimum",
  "common.more": "Egyéb",
  "common.moreInformation": "További információ",
  "common.next": "Következő",
  "common.no": "Nem",
  "common.noAccountNeeded": "Nincs szükség fiókra",
  "common.noItemsAvailable": "Nincsenek elérhető elemek",
  "common.notNow": "Most nem",
  "common.now": "Most",
  "common.openSettings": "Nyissa meg a beállításokat",
  "common.outdoor": "Kültér",
  "common.pageNotFound": "Az oldal nem található",
  "common.pageNotFoundDescription": "A keresett oldal nem létezik vagy áthelyezték.",
  "common.rain": "Csapadék",
  "common.reorderCancel": "Áthelyezés megszakítva: {item}. Újra a(z) {position}. helyen a(z) {count} közül.",
  "common.reorderEnd": "Lerakva: {item}. Pozíció: {position} / {count}.",
  "common.reorderInstructions": "Az elem áthelyezéséhez nyomja meg a szóközt vagy az Entert, válassza ki a helyét a fel és le nyilakkal, majd nyomja meg újra a szóközt vagy az Entert a lerakáshoz, vagy az Escape-et a megszakításhoz.",
  "common.reorderOver": "{item} – most a(z) {position}. helyen a(z) {count} közül.",
  "common.reorderStart": "Felvéve: {item}. Pozíció: {position} / {count}.",
  "common.share": "Ossza meg",
  "common.shareImageFailed": "Nem sikerült megosztani a képet",
  "common.shareYourWeather": "Ossza meg időjárását",
  "common.skip": "Kihagyás",
  "common.start": "Kezdés",
  "common.unknown": "Ismeretlen",
  "common.validate": "Megerősítés",
  "common.validEmail": "Érvényes e-mail cím szükséges.",
  "common.very_low": "Nagyon alacsony",
  "common.weatherObservations": "Időjárási megfigyelések",
  "common.welcome": "Üdvözöl a SmartMixin!",
  "common.wind": "Szél",
  "common.yes": "Igen",
  "common.zoomImage": "Kép nagyítása",
  "compass.E": "K",
  "compass.E_long": "Kelet",
  "compass.ENE": "KÉK",
  "compass.ENE_long": "Kelet-északkelet",
  "compass.ESE": "KDK",
  "compass.ESE_long": "Kelet-délkelet",
  "compass.N": "É",
  "compass.N_long": "Észak",
  "compass.NE": "ÉK",
  "compass.NE_long": "Északkelet",
  "compass.NNE": "ÉÉK",
  "compass.NNE_long": "Észak-északkelet",
  "compass.NNW": "ÉÉNy",
  "compass.NNW_long": "Észak-északnyugat",
  "compass.NW": "ÉNy",
  "compass.NW_long": "Északnyugat",
  "compass.S": "D",
  "compass.S_long": "Dél",
  "compass.SE": "DK",
  "compass.SE_long": "Délkelet",
  "compass.SSE": "DDK",
  "compass.SSE_long": "Dél-délkelet",
  "compass.SSW": "DDNy",
  "compass.SSW_long": "Dél-délnyugat",
  "compass.SW": "DNy",
  "compass.SW_long": "Délnyugat",
  "compass.W": "Ny",
  "compass.W_long": "Nyugat",
  "compass.WNW": "NyÉNy",
  "compass.WNW_long": "Nyugat-északnyugat",
  "compass.WSW": "NyDNy",
  "compass.WSW_long": "Nyugat-délnyugat",
  "dashboard.currentObservations": "Legújabb észlelések",
  "dashboard.currentRainEvent": "Aktuális esőesemény",
  "dashboard.currentWeatherConditions": "Aktuális időjárás",
  "dashboard.customizeDashboard": "Testreszabás",
  "dashboard.customizeDashboardDescription": "Húzza az elemeket az irányítópult átrendezéséhez. Koppintson a szem ikonra a szakaszok megjelenítéséhez vagy elrejtéséhez.",
  "dashboard.dashboard": "Irányítópult",
  "dashboard.dayRangeExpected": "{value} várható {time}-kor",
  "dashboard.dayRangeReached": "{value} {time}-kor",
  "dashboard.dayRangeSteady": "Egész nap állandó {value}",
  "dashboard.hiddenSensors": "Rejtett érzékelők",
  "dashboard.hideSensor": "{sensor} elrejtése",
  "dashboard.lastRainEvent": "Utolsó esőesemény",
  "dashboard.lastVisibleSensor": "Legalább egy érzékelőnek láthatónak kell maradnia.",
  "dashboard.manageSensors": "Érzékelők kezelése",
  "dashboard.manageSensorsDescription": "Húzza az elemeket az érzékelők átrendezéséhez. Koppintson a szem ikonra az érzékelők megjelenítéséhez vagy elrejtéséhez. Koppintson egy névre az átnevezéshez.",
  "dashboard.manageSensorsDescriptionWeb": "Kattintson a ceruzára egy érzékelő átnevezéséhez, húzza a fogantyúját a lista átrendezéséhez, és kattintson a szemre az elrejtéséhez vagy megjelenítéséhez.",
  "dashboard.moveSensor": "{sensor} áthelyezése",
  "dashboard.pressureSummary": "Légnyomás-összefoglaló",
  "dashboard.rainEvents": "Esőesemények",
  "dashboard.rainSummary": "Csapadék-összefoglaló",
  "dashboard.renameSensor": "{sensor} átnevezése",
  "dashboard.shareOutdoorMeasures": "Ossza meg kültéri méréseit",
  "dashboard.shareOutdoorMeasuresDescription": "Vegyen részt a SmartMixin közösségben külső adatainak megosztásával. A beltéri modulok adatai soha nem lesznek megosztva.",
  "dashboard.showSensor": "{sensor} megjelenítése",
  "dashboard.temperatureSummary": "Hőmérséklet-összefoglaló",
  "dashboard.useDefaultSensorName": "Alapértelmezett név használata",
  "dashboard.windSummary": "Szélösszefoglaló",
  "devices.batteryLevel": "Akkumulátor töltöttsége",
  "devices.firmwareVersion": "Firmware verzió",
  "devices.moduleCount": "{count, plural, one {# modul} other {# modul}}",
  "devices.moduleType": "Modultípus",
  "devices.noNetatmoWeatherStationYet": "Még nincs Netatmo időjárás-állomása.",
  "devices.noOutdoorModule": "Ehhez az állomáshoz nincs működő kültéri modul.",
  "devices.notReachable": "Nem érhető el",
  "devices.serialNumber": "Sorozatszám",
  "devices.signalAverage": "Közepes",
  "devices.signalBad": "Gyenge",
  "devices.signalGood": "Jó",
  "devices.signalStrength": "Jelerősség",
  "devices.signalUnknown": "Ismeretlen",
  "devices.visitNetatmoWebsite": "Netatmo weboldalának felkeresése",
  "devices.wifiStrength": "Wi-Fi jelerősség",
  "forecastMaps.addColor": "Szín hozzáadása",
  "forecastMaps.addLayer": "Réteg hozzáadása",
  "forecastMaps.autoDescription": "A legjobb elérhető ehhez a nézethez",
  "forecastMaps.autoDescriptionFree": "Az ingyenes fiókok ezt használják: {model}",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.autoSwitched": "Most {model} látható: {previous} a nézet {coverage, number, percent}-át fedi le",
  "forecastMaps.backToMaps": "Vissza a térképekhez",
  "forecastMaps.build": "Generálás",
  "forecastMaps.buildCompleted": "Generálás kész",
  "forecastMaps.builderMetaDescription": "Állítson össze egyéni előrejelzési térképeket az időjárási modellek rétegeiből.",
  "forecastMaps.builderTitle": "Térképszerkesztő",
  "forecastMaps.buildFailed": "A generálás nem sikerült. Próbálja újra.",
  "forecastMaps.buildNotPossible": "Ez a térkép még nem generálható — nincs elérhető előrejelzési adat.",
  "forecastMaps.buildProgress": "Renderelés… {completed}/{total} lépés",
  "forecastMaps.buildStarting": "Generálás indítása…",
  "forecastMaps.byModel": "Modell szerint",
  "forecastMaps.byZone": "Zóna szerint",
  "forecastMaps.colormap": "Színskála",
  "forecastMaps.colormapCustom": "Egyéni színek",
  "forecastMaps.colormapGroupDomain": "Időjárási sablonok",
  "forecastMaps.colormapGroupMatplotlib": "Tudományos sablonok",
  "forecastMaps.colorStop": "{position}. szín",
  "forecastMaps.configUnavailable": "Ez az előrejelzési térkép nem érhető el. Helyette ez látható: {name}.",
  "forecastMaps.contourLevels": "Kontúrszintek",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Franciaország",
  "forecastMaps.countryGermany": "Németország",
  "forecastMaps.countryItaly": "Olaszország",
  "forecastMaps.countryScandinavia": "Skandinávia",
  "forecastMaps.countrySpain": "Spanyolország",
  "forecastMaps.countrySwitzerland": "Svájc",
  "forecastMaps.countryUnitedStates": "Egyesült Államok",
  "forecastMaps.coverageUnknown": "Ismeretlen terület",
  "forecastMaps.coversView": "A nézet {coverage, number, percent}-át fedi le",
  "forecastMaps.customColormapMinColors": "Az egyéni színskálához legalább két szín szükséges",
  "forecastMaps.customExtent": "Egyéni kivágat",
  "forecastMaps.displayName": "Megjelenített név",
  "forecastMaps.downscaling": "Szélzászló-ritkítási tényező",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Terület rajzolása",
  "forecastMaps.east": "Kelet",
  "forecastMaps.extentDrawHint": "Húzással rajzolja meg a területet a térképen",
  "forecastMaps.extentInvalid": "A nyugatnak kisebbnek kell lennie a keletnél, a délnek az északnál",
  "forecastMaps.frameTime": "Előrejelzés időpontja",
  "forecastMaps.height": "Magasság (hüvelyk)",
  "forecastMaps.hourOffset": "+{hour} ó",
  "forecastMaps.inThisArea": "Ezen a területen",
  "forecastMaps.invalidHexColor": "Érvénytelen szín — használjon #RRGGBB formátumot",
  "forecastMaps.layerHasErrors": "Ez a réteg hibákat tartalmaz",
  "forecastMaps.layers": "Rétegek",
  "forecastMaps.layerTypeBarbs": "Szélzászlók",
  "forecastMaps.layerTypeContour": "Kontúrvonalak",
  "forecastMaps.layerTypeFilledContour": "Kitöltött kontúrok",
  "forecastMaps.layerTypeMagnitude": "Nagyság",
  "forecastMaps.layerTypeRaster": "Raszter",
  "forecastMaps.layerTypeVectorField": "Vektormező",
  "forecastMaps.leave": "Kilépés",
  "forecastMaps.levelsCount": "Darabszám",
  "forecastMaps.levelsInvalid": "Érvénytelen kontúrszintek",
  "forecastMaps.levelsModeArange": "Rögzített lépésköz",
  "forecastMaps.levelsModeExplicit": "Explicit értékek",
  "forecastMaps.levelsModeLinspace": "Egyenletes eloszlás (darabszám)",
  "forecastMaps.levelsStep": "Lépésköz",
  "forecastMaps.levelsValues": "Értékek",
  "forecastMaps.levelsValuesHint": "Vesszővel elválasztva, növekvő sorrendben",
  "forecastMaps.loadingMaps": "Térképek betöltése…",
  "forecastMaps.localTimeHint": "A helyi idő szerint megjelenítve",
  "forecastMaps.lockedConfig": "A(z) {model} Premium modell. Helyette ez látható: {fallback}.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Leírás",
  "forecastMaps.mapName": "Térkép neve",
  "forecastMaps.mapNameRequired": "Adjon meg egy nevet",
  "forecastMaps.mapSettings": "Térképbeállítások",
  "forecastMaps.maxLayersReached": "Ez a térkép elérte a maximális {max} réteget.",
  "forecastMaps.maxValue": "Maximális érték",
  "forecastMaps.memoryBudgetExceeded": "A felbontás túllépi a renderelési keretet — csökkentse a DPI-t vagy a magasságot",
  "forecastMaps.memoryBudgetUsage": "Renderelési keret: {percent}%",
  "forecastMaps.metaDescription": "Animált előrejelzési térképek az időjárási modellek futásaiból.",
  "forecastMaps.metric": "Mérőszám",
  "forecastMaps.metricRequired": "Válasszon mérőszámot",
  "forecastMaps.metricUnavailable": "Ehhez a modellhez nem érhető el",
  "forecastMaps.minBelowMax": "A minimumnak kisebbnek kell lennie a maximumnál",
  "forecastMaps.minMaxRequired": "Ehhez a rétegtípushoz minimum- és maximumérték szükséges",
  "forecastMaps.minValue": "Minimális érték",
  "forecastMaps.modelChipAuto": "Auto · {model}",
  "forecastMaps.modelCoversView": "{model} a nézet {coverage, number, percent}-át fedi le",
  "forecastMaps.modelNoRun": "Még nincs befejezett futás",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.moveLayerDown": "Mozgatás lefelé",
  "forecastMaps.moveLayerUp": "Mozgatás felfelé",
  "forecastMaps.nanClipToMin": "Levágás a minimumra",
  "forecastMaps.nanMask": "Maszkolás",
  "forecastMaps.nanPolicy": "Hiányzó adatok",
  "forecastMaps.nanSkip": "Kihagyás",
  "forecastMaps.noCompletedRun": "Ez a térkép még nem készült el. Nézzen vissza hamarosan.",
  "forecastMaps.noLayers": "Még nincs réteg. Adjon hozzá egy réteget a kezdéshez.",
  "forecastMaps.noMapsAvailable": "Még nincsenek elérhető előrejelzési térképek.",
  "forecastMaps.north": "Észak",
  "forecastMaps.opacity": "Átlátszatlanság",
  "forecastMaps.openAsAnimation": "Megnyitás animációként",
  "forecastMaps.otherAreas": "Más területek",
  "forecastMaps.outsideArea": "Nem fedi le ezt a területet",
  "forecastMaps.overlayLegend": "Jelmagyarázat",
  "forecastMaps.pause": "Szünet",
  "forecastMaps.play": "Lejátszás",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "Nem sikerült betölteni az előrejelzést ehhez a ponthoz.",
  "forecastMaps.pointValueLoading": "Előrejelzés betöltése…",
  "forecastMaps.pointValueUnavailable": "Nincs adat ehhez az időponthoz.",
  "forecastMaps.premiumModelForView": "{model} lefedi ezt a nézetet",
  "forecastMaps.premiumRequired": "Az előrejelzési térképekhez Premium szükséges",
  "forecastMaps.preview": "Előnézet",
  "forecastMaps.previewEmptyHint": "Állítson be legalább egy érvényes réteget az előnézet rendereléséhez.",
  "forecastMaps.previewFailed": "Az előnézet nem sikerült",
  "forecastMaps.previewHour": "Előrejelzési óra",
  "forecastMaps.previewRendering": "Előnézet renderelése…",
  "forecastMaps.projection": "Vetület",
  "forecastMaps.projectionLambertConformal": "Lambert-féle szögtartó",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Sztereografikus",
  "forecastMaps.regionEurope": "Európa",
  "forecastMaps.regionNorthAmerica": "Észak-Amerika",
  "forecastMaps.removeColor": "Szín eltávolítása",
  "forecastMaps.removeLayer": "Réteg eltávolítása",
  "forecastMaps.retry": "Újra",
  "forecastMaps.run": "Futás: {run}",
  "forecastMaps.runNotDisplayable": "Ez a futás nem jeleníthető meg az interaktív térképen.",
  "forecastMaps.save": "Mentés",
  "forecastMaps.selectExtentOnMap": "Terület kijelölése a térképen",
  "forecastMaps.showArea": "Terület mutatása",
  "forecastMaps.showAreaOf": "Terület mutatása, {model}",
  "forecastMaps.south": "Dél",
  "forecastMaps.switchToModel": "Váltás erre: {model}",
  "forecastMaps.title": "Előrejelzési térképek",
  "forecastMaps.uMetric": "U-komponens",
  "forecastMaps.unitConversion": "Mértékegység-átváltás",
  "forecastMaps.unitNone": "Nincs",
  "forecastMaps.unsavedChangesBody": "Nem mentett módosításai vannak. Kilép és elveti őket?",
  "forecastMaps.unsavedChangesTitle": "Nem mentett módosítások",
  "forecastMaps.useCurrentView": "Jelenlegi nézet használata",
  "forecastMaps.useModelDomain": "Ki: a modell teljes tartománya lesz használva",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Az U és V mérőszámoknak különbözniük kell",
  "forecastMaps.valueBetween": "{min} és {max} között kell lennie",
  "forecastMaps.variable": "Változó",
  "forecastMaps.variableMissing": "{variable} nem érhető el",
  "forecastMaps.variableOnlyFrom": "{variable} csak ebből érhető el: {model}",
  "forecastMaps.viewMap": "Térkép megtekintése",
  "forecastMaps.vMetric": "V-komponens",
  "forecastMaps.west": "Nyugat",
  "forecastMaps.windAnimation": "Szélanimáció",
  "forecastModels.addForecastModel": "Modell hozzáadása",
  "forecastModels.atYourStations": "Elérhető az Ön állomásain",
  "forecastModels.comparisonLoadError": "Nem sikerült betölteni az időjárási modellek összehasonlítását",
  "forecastModels.coverageLoading": "Kiszámítjuk, mely állomásait fedi le az egyes modellek…",
  "forecastModels.description_AROME": "A Météo France konvekciót feloldó nagy felbontású modellje Nyugat-Európa felett 1,3 km felbontással. A legjobb a maga kategóriájában a franciaországi rövid távú előrejelzésekhez; háromóránként frissül.",
  "forecastModels.description_ARPEGE_EU": "A Météo France ARPEGE modelljének európai beágyazott tartománya 10 km felbontással. Középtávú előrejelzések Európa felett, naponta négyszer frissülnek.",
  "forecastModels.description_ARPEGE_GLOBAL": "A Météo France globális numerikus időjárási modellje 25 km felbontással, kb. 4 napig fut. Naponta négyszer frissül.",
  "forecastModels.description_DMI_DINI": "A DMI HARMONIE DINI modellje: konvekciót felbontó modell Északnyugat-Európa felett — Dánia, a Benelux-államok, Írország, az Egyesült Királyság és Skandinávia —, 2 km felbontással, 60 óráig fut, naponta nyolcszor frissül. Módosított DMI nyílt adatokat tartalmaz (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Az Environment Canada Global Deterministic Prediction System (globális determinisztikus előrejelző rendszer) modellje: globális középtávú modell 15 km felbontással, 10 napig fut, naponta kétszer frissül.",
  "forecastModels.description_EC_HRDPS": "Az Environment Canada High Resolution Deterministic Prediction System (nagy felbontású determinisztikus előrejelző rendszer) modellje: konvekciót felbontó modell Kanada és az Amerikai Egyesült Államok északi része felett 2,5 km felbontással, 48 óráig fut, naponta négyszer frissül.",
  "forecastModels.description_EC_RDPS": "Az Environment Canada Regional Deterministic Prediction System (regionális determinisztikus előrejelző rendszer) modellje: középtávú modell Észak-Amerika felett 10 km felbontással, naponta négyszer frissül.",
  "forecastModels.description_ECMWF_HRES": "Az Európai Középtávú Időjárás-előrejelző Központ nagy felbontású zászlóshajó-modellje (IFS), amelyet széles körben a világ vezető globális előrejelző rendszerének tartanak. Az egész bolygót lefedi 25 km-es felbontással 15 napig, naponta négyszer frissül. Módosított ECMWF nyílt adatokat tartalmaz (CC BY 4.0).",
  "forecastModels.description_GFS": "A NOAA zászlóshajó középtávú globális modellje. Az egész bolygót lefedi 25 km felbontással, akár 16 napig, naponta négyszer frissül.",
  "forecastModels.description_HRRR_CONUS": "A NOAA High-Resolution Rapid Refresh modellje: konvekciót feloldó modell az Egyesült Államok kontinentális területe felett 3 km felbontással, óránként frissül. Leginkább nagyon rövid távú zivatar- és extrém időjárás-előrejelzésekhez ajánlott.",
  "forecastModels.description_ICON": "A DWD globális ICON modellje 13 km-es felbontással, amely az egész bolygót lefedi 7,5 napig, naponta négyszer frissül. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "Az ItaliaMeteo ICON-2I modellje, az ARPAE-vel közösen üzemeltetve: konvekciót felbontó modell Olaszország felett, 2,2 km felbontással, 72 óráig fut, naponta kétszer frissül. ItaliaMeteo nyílt adatokat tartalmaz (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "A MeteoSwiss ICON-CH1-EPS kontrollfutása: konvekciót felbontó modell az Alpok felett, 1 km felbontással, 33 óráig fut, háromóránként frissül.",
  "forecastModels.description_ICON_CH2": "A MeteoSwiss ICON-CH2-EPS kontrollfutása: konvekciót felbontó modell az Alpok felett — Svájc és a környező alpesi térség —, 2,1 km felbontással, 120 óráig fut, naponta négyszer frissül.",
  "forecastModels.description_ICON_DE": "A DWD nagy felbontású konvekciót feloldó modellje Németország és a környező országok felett 2,2 km felbontással. Rövid távú előrejelzések naponta kétszer frissülnek. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "A DWD ICON modelljének európai beágyazott tartománya 7 km felbontással, Európát és az Észak-Atlanti-óceánt lefedi. Középtávú előrejelzések naponta négyszer frissülnek. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "A Norvég Meteorológiai Intézet nyílt időjárás-előrejelző szolgáltatása, amely a nagy felbontású északi modelleket az ECMWF adataival kombinálja, hogy akár 10 napos globális előrejelzéseket biztosítson.",
  "forecastModels.description_MF_AROME_ANTILLES": "Beágyazott AROME-tartomány a Francia Antillák felett (Guadeloupe, Martinique) 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "forecastModels.description_MF_AROME_GUYANE": "Beágyazott AROME-tartomány Francia Guyana felett 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Beágyazott AROME-tartomány Új-Kaledónia felett 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Beágyazott AROME-tartomány Francia Polinézia felett 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Beágyazott AROME-tartomány Réunion és Mayotte felett 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "forecastModels.description_RRFS_CONUS": "A NOAA Rapid Refresh Forecast rendszere az Egyesült Államok kontinentális területe felett 3 km felbontással. Órás előrejelzések naponta nyolcszor frissülnek, a négy fő futtatásnál 84 óráig, a többinél 18 óráig.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "A NOAA Rapid Refresh Forecast rendszere, amely egész Észak-Amerikát lefedi 13 km felbontással. Órás előrejelzések 84 óráig, naponta négyszer frissül.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "A SmartMixin zászlóshajó előrejelzése. Az Ön helyén minden órára kiválasztjuk a legjobb elérhető modellt — általában egy nagy felbontású regionális modellt ott, ahol létezik (AROME Franciaországban, ICON-D2 Németországban, HRRR az Egyesült Államokban, ARPEGE Europe a kontinens egészén…) és máshol egy globális modellre térünk vissza — majd kitöltjük a hiányosságokat a szomszédos forrásokból. Az eredmény egyetlen zökkenőmentes előrejelzés, amely 14 napig lefedi a világon bárhol, és automatikusan frissül, amikor bármelyik alapul szolgáló modellt frissítik.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "A Weatherflow saját globális előrejelzése, amely több numerikus időjárási modellt kever a Tempest meteorológiai állomások hálózatának megfigyeléseivel. 10 napos globális horizont.",
  "forecastModels.everywhereElse": "Mindenhol máshol",
  "forecastModels.everywhereElseFoot": "Minden olyan állomáson használatos, amelyet az előnyben részesített modelljei nem érnek el.",
  "forecastModels.everywhereElsePick": "Válasszon egyet",
  "forecastModels.fallbackBlend": "SmartMixin keverék",
  "forecastModels.fallbackBlendSub": "Több modellt kombinál, mindegyiket ott, ahol a legerősebb.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES mindenhol, ahová elér.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "A NOAA globális modellje. Ezt használja ma minden fiók.",
  "forecastModels.fallbackResolution": "Legnagyobb felbontás",
  "forecastModels.fallbackResolutionSub": "Az egyes állomásokon elérhető legfinomabb rács.",
  "forecastModels.forecastChipLabelWithRun": "{model}, futás: {run}",
  "forecastModels.forecastChipRunHint": "Hosszan nyomja meg a legutóbbi futás megjelenítéséhez vagy elrejtéséhez",
  "forecastModels.forecastComparisonDescription": "Könnyen összehasonlíthatja a különböző rendelkezésre álló időjárási modellek adatait",
  "forecastModels.forecastFollowingPreferences": "A beállításait követve",
  "forecastModels.forecastLoadError": "Nem sikerült betölteni az előrejelzést",
  "forecastModels.forecastModel": "Előrejelzési modell",
  "forecastModels.forecastModelAbout": "A(z) {model} modellről",
  "forecastModels.forecastModelComparison": "Az időjárási modellek összehasonlítása",
  "forecastModels.forecastModelCoverage": "Lefedettség",
  "forecastModels.forecastModelDescription": "Leírás",
  "forecastModels.forecastModels": "Előrejelzési modellek",
  "forecastModels.forecastModelScopeGlobal": "Globális",
  "forecastModels.forecastModelScopeGlobalDescription": "Ez a modell az egész bolygót lefedi.",
  "forecastModels.forecastModelScopeRegional": "Regionális",
  "forecastModels.forecastModelScopeRegionalDescription": "Ez a modell csak egy adott régiót fed le.",
  "forecastModels.forecastModelSpecifications": "Műszaki adatok",
  "forecastModels.forecastNoPinLocation": "Egyik előnyben részesített modell sem éri el ezt a helyet — a „mindenhol máshol” dönt.",
  "forecastModels.forecastNoPinStation": "Egyik előnyben részesített modell sem éri el ezt az állomást — a „mindenhol máshol” dönt.",
  "forecastModels.forecastNoPreferredModels": "Még nincs beállítva előnyben részesített modell.",
  "forecastModels.forecastOverrideElsewhere": "A beállításai mindenhol máshol érvényesek.",
  "forecastModels.forecastPickForLocation": "Vagy válasszon egyet ehhez a helyhez",
  "forecastModels.forecastPickForStation": "Vagy válasszon egyet ehhez az állomáshoz",
  "forecastModels.forecastPinWinsLocation": "{model} — az első előnyben részesített modellje, amely eléri ezt a helyet.",
  "forecastModels.forecastPinWinsStation": "{model} — az első előnyben részesített modellje, amely eléri ezt az állomást.",
  "forecastModels.forecastServedNowHere": "Jelenleg itt: {model}",
  "forecastModels.forecastSetForLocation": "Beállítva ehhez a helyhez",
  "forecastModels.forecastSetForStation": "Beállítva ehhez az állomáshoz",
  "forecastModels.forecastSettingsRowSub": "Előnyben részesített modellek, és ami mindenhol máshol érvényes",
  "forecastModels.forecastStopUsingHere": "Ne használja itt",
  "forecastModels.forecastUseForLocation": "{model} használata ehhez a helyhez",
  "forecastModels.forecastUseForStation": "{model} használata ehhez az állomáshoz",
  "forecastModels.forecastUsePreferred": "Előnyben részesített modelljeim használata",
  "forecastModels.frequencyHourly": "Óránként",
  "forecastModels.horizon": "Előrejelzési időtáv",
  "forecastModels.horizonValue": "legfeljebb {value} óra",
  "forecastModels.meshSize": "Rács mérete",
  "forecastModels.pickerShowAll": "Teljes katalógus megjelenítése",
  "forecastModels.pickerUnreachable": "{count, plural, one {# további modell nem éri el} other {# további modell nem éri el}} egyik állomását sem",
  "forecastModels.pinInUse": "Használatban",
  "forecastModels.pinShadowed": "Soha nincs használatban — egy fenti modell lefedi az összes állomását",
  "forecastModels.pinSlots": "{used} / {max} · válasszon modellt",
  "forecastModels.pinSlotsFull": "{max, plural, one {Az egyetlen hely foglalt. Távolítsa el a modelljét, hogy másikat adhasson hozzá.} other {Mind a(z) # hely foglalt. Távolítson el egyet, hogy másikat adhasson hozzá.}}",
  "forecastModels.pinsUncoveredCount": "{count, plural, other {# állomásából}} {used}: egyik előnyben részesített modell sem éri el {used, plural, =1 {azt} other {azokat}} — a „mindenhol máshol” dönt.",
  "forecastModels.pinsUncoveredNamed": "{stations}: egyik előnyben részesített modell sem éri el {count, plural, one {azt} other {azokat}} — a „mindenhol máshol” dönt.",
  "forecastModels.pinUnreachable": "Soha nincs használatban — egyik állomását sem éri el",
  "forecastModels.pinUsedAt": "Használatban itt: {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Az állomásán használatban} other {Mind a(z) # állomáson használatban}}",
  "forecastModels.pinUsedAtSome": "{count, plural, other {# állomásból}} {used} helyen használatban",
  "forecastModels.preferredModels": "Előnyben részesített modellek",
  "forecastModels.preferredModelsAll": "Egy lista, minden állomás",
  "forecastModels.preferredModelsOne": "Egy lista, mindenhol érvényes",
  "forecastModels.publisher": "Kiadó",
  "forecastModels.removePreferredModel": "{model} eltávolítása az előnyben részesített modellek közül",
  "forecastModels.resetForecastPreference": "Alapértelmezés visszaállítása",
  "forecastModels.resetForecastPreferenceHint": "Törli az előnyben részesített modelljeit, és visszaáll a SmartMixin alapértelmezésére.",
  "forecastModels.servedNowMany": "Jelenleg: GFS {count, plural, one {az Ön állomásán} other {mind a(z) # állomáson}}.",
  "forecastModels.servedNowNone": "Jelenleg: GFS mindenhol.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodell",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Weatherflow-előrejelzés",
  "forecastModels.weatherForecastModels": "Időjárás-előrejelzési modellek",
  "helpCenter.articleCount": "{count} cikk",
  "helpCenter.articleNotFound": "A cikk nem található",
  "helpCenter.articleNotFoundDescription": "A keresett cikk nem létezik.",
  "helpCenter.backToHelpCenter": "Vissza a súgóközpontba",
  "helpCenter.browseByCategory": "Böngészés kategória szerint",
  "helpCenter.categoryNotFound": "Kategória nem található",
  "helpCenter.categoryNotFoundDescription": "Ez a kategória nem létezik vagy nincsenek benne cikkek.",
  "helpCenter.contactSupport": "Kapcsolatfelvétel az ügyfélszolgálattal",
  "helpCenter.feedbackHelpsImprove": "Visszajelzése segít nekünk javítani súgócikkeinket.",
  "helpCenter.feedbackReasonNotAnswer": "Nem válaszol a kérdésemre",
  "helpCenter.feedbackReasonOutdated": "Az információk elavultak",
  "helpCenter.feedbackReasonUnclear": "Az útmutató nem egyértelmű",
  "helpCenter.feedbackWhatWentWrong": "Mi volt a probléma?",
  "helpCenter.helpCategoryAccount": "Fiók",
  "helpCenter.helpCategoryBilling": "Számlázás",
  "helpCenter.helpCategoryForecast": "Előrejelzések",
  "helpCenter.helpCategoryGettingStarted": "Első lépések",
  "helpCenter.helpCategoryProviders": "Szolgáltatók",
  "helpCenter.helpCategoryStations": "Állomások",
  "helpCenter.helpCategoryTroubleshooting": "Hibaelhárítás",
  "helpCenter.helpCenter": "Súgóközpont",
  "helpCenter.landingDescription": "Találjon válaszokat a gyakori kérdésekre, és ismerje meg, hogyan hozhatja ki a legtöbbet a SmartMixinből.",
  "helpCenter.linkToSection": "Hivatkozás erre a szakaszra",
  "helpCenter.menuItemDescription": "GYIK és útmutatók",
  "helpCenter.minRead": "{minutes} perc olvasás",
  "helpCenter.onThisPage": "Ezen az oldalon",
  "helpCenter.platformMobileApp": "Mobilalkalmazás",
  "helpCenter.platformMobileOnly": "Csak a mobilalkalmazásban",
  "helpCenter.platformWebApp": "Webalkalmazás",
  "helpCenter.platformWebOnly": "Csak a webalkalmazásban",
  "helpCenter.popularArticles": "Népszerű cikkek",
  "helpCenter.relatedArticles": "Kapcsolódó cikkek",
  "helpCenter.searchArticles": "Cikkek keresése...",
  "helpCenter.stillNeedHelp": "További segítségre van szüksége?",
  "helpCenter.stillNeedHelpDescription": "Ha ez a cikk nem válaszolta meg a kérdését, szívesen segítek közvetlenül.",
  "helpCenter.supportEmailSubject": "SmartMixin súgó",
  "helpCenter.supportEmailSubjectTopic": "SmartMixin súgó — {topic}",
  "helpCenter.thankYouForFeedback": "Köszönjük a visszajelzést!",
  "helpCenter.wasArticleHelpful": "Hasznos volt ez a cikk?",
  "intro.locationDescription": "Engedélyezd a helymeghatározást, hogy pontos, pontosan a területedre szabott időjárás‑előrejelzéseket kapj — nincs több általános előrejelzés.",
  "intro.locationTitle": "Előrejelzések neked szabva",
  "intro.notificationDescription": "Kapcsold be az értesítéseket, hogy időben figyelmeztetéseket kapj a számodra fontos időjárás‑változásokról — eső, hó vagy extrém körülmények, amikor csak kell.",
  "intro.notificationsTitle": "Ne maradj le egy időjárás‑változásról sem",
  "intro.readyDescription": "Élvezd a pontos előrejelzéseket, valós idejű időjárás‑információkat és állomásadatokat a világ minden tájáról — egyetlen erőteljes alkalmazásban.",
  "intro.readyTitle": "Készen állsz!",
  "intro.welcomeDescription": "Hiperlokális előrejelzések az iparág legjobb meteorológiai ügynökségeitől — plusz hozzáférés több mint 40 000 időjárási állomáshoz világszerte, hogy lásd a tényleges körülményeket, jelenleg és múltban.",
  "intro.welcomeTitle": "Időjárás újragondolva",
  "landing.alsoAvailableOn": "Elérhető még:",
  "landing.featureAlertsDescription": "Állítson be egyéni küszöbértékeket bármely mért adatra. Kapjon értesítést, ha csökken a hőmérséklet, elered az eső vagy feltámad a szél.",
  "landing.featureAlertsTitle": "Intelligens riasztások",
  "landing.featureAnalyticsDescription": "Interaktív diagramok, trendelemzés és részletes statisztikák. Merüljön el a hőmérséklet-, páratartalom-, légnyomás-, eső- és széladatokban.",
  "landing.featureAnalyticsTitle": "Fejlett elemzések",
  "landing.featureExportDescription": "Kapja meg összes időjárási adatát e-mailben Excel-táblázatként, további elemzésre készen az Excelben, a Google Táblázatokban vagy kedvenc eszközeiben.",
  "landing.featureExportTitle": "Exportálja adatait",
  "landing.featureForecastDescription": "{count, plural, one {#+ professzionális előrejelzési modell} other {#+ professzionális előrejelzési modell}}, köztük az ECMWF, a GFS és regionális modellek. Hasonlítsa össze őket egymás mellett, és készítse el saját előrejelzését.",
  "landing.featureForecastTitle": "Hasonlítsa össze az előrejelzési modelleket",
  "landing.featureHistoryDescription": "Hozzáférés a korábbi adatokhoz óránkénti, napi és havi skálán. Exportálja őket Excelbe kutatáshoz vagy személyes archívumba.",
  "landing.featureHistoryTitle": "Gazdag előzmények",
  "landing.featureMultiBrandDescription": "Csatlakoztassa a Netatmo, Davis, Tempest, Ecowitt, Ambient Weather és más márkák állomásait. Nincs többé váltogatás az alkalmazások között.",
  "landing.featureMultiBrandTitle": "Minden márka, egy alkalmazás",
  "landing.featuresSubtitle": "A SmartMixin megadja az eszközöket ahhoz, hogy profi módon elemezze, összehasonlítsa és megértse időjárási adatait.",
  "landing.featuresTitle": "Adatrajongóknak készült",
  "landing.finalCtaButton": "Ingyenes fiók létrehozása",
  "landing.finalCtaSubtitle": "Csatlakozzon több ezer időjárás-rajongóhoz, akik a SmartMixinben bíznak.",
  "landing.finalCtaTitle": "Készen áll, hogy mélyebben elmerüljön időjárási adataiban?",
  "landing.heroCta": "Ingyenes kezdés",
  "landing.heroDescription": "Mélyreható elemzések, látványos diagramok és professzionális előrejelzések — az összes időjárás-állomása egyetlen hatékony alkalmazásban.",
  "landing.heroSecondaryCta": "Térkép felfedezése",
  "landing.heroTagline": "Időjárás-rajongóknak",
  "landing.heroTitle": "Lássa az időjárását úgy, mint még soha",
  "landing.pricingComparisonCaption": "Az ingyenes és a Premium csomag funkcióinak összehasonlítása",
  "landing.pricingFeatureAdvancedMetrics": "Haladó mérőszámok",
  "landing.pricingFeatureAlerts": "Egyéni riasztások",
  "landing.pricingFeatureColumn": "Funkció",
  "landing.pricingFeatureExport": "Adatexport (Excel)",
  "landing.pricingFeatureForecastComparison": "Előrejelzés-összehasonlítás",
  "landing.pricingFeatureForecasts": "Előrejelzési modellek",
  "landing.pricingFeatureForecastsFreeTier": "1 modell",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ modell} other {#+ modell}}",
  "landing.pricingFeatureReports": "Elemzések és jelentések",
  "landing.pricingFeatureStationComparison": "Állomások összehasonlítása",
  "landing.pricingFeatureWidgets": "Kezdőképernyő widgetek",
  "landing.pricingFeatureYearOverYear": "Éves összehasonlító elemzés",
  "landing.pricingFreeCta": "Kezdje el",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Legnépszerűbb",
  "landing.pricingPremiumCta": "Kezdje el",
  "landing.pricingPremiumDescription": "1,99 €/hónaptól — fizessen elő weben, App Store-ban vagy Google Playen",
  "landing.pricingSubtitle": "Kezdje ingyenesen, frissítsen, amikor többre van szüksége.",
  "landing.pricingTitle": "Egyszerű, átlátható árazás",
  "landing.statBrands": "Támogatott márka",
  "landing.statForecasts": "Előrejelzési modell",
  "landing.statStations": "Meteorológiai állomás",
  "landing.supportedDevicesNote": "Valamint több mint {count, number} nyilvános állomás a Meteorológiai Világszervezet hálózatából",
  "landing.supportedDevicesSubtitle": "Csatlakoztassa meglévő időjárás-állomását percek alatt. {count, plural, one {# nagy márkát} other {# nagy márkát}} támogatunk, és a lista folyamatosan bővül.",
  "landing.supportedDevicesTitle": "Működik az Ön állomásával",
  "metrics.absolutePressure": "Abszolút nyomás",
  "metrics.airDensity": "Légsűrűség",
  "metrics.airGap": "Légrés",
  "metrics.apparentTemperature": "Látszólagos hőmérséklet",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Átlag",
  "metrics.avg_wind": "Átlagos szél",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Fekete gömb hőm.",
  "metrics.boilerOn": "Kazán aktivitás",
  "metrics.boilerOnInHours": "Kazán aktivitás (óra)",
  "metrics.cloudCover": "Felhőzet",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Vezetőképesség",
  "metrics.dailyPrecipitation": "Napi csapadék",
  "metrics.dailyRain": "Napi csapadék",
  "metrics.degreeDayShort": "DD",
  "metrics.depth": "Mélység",
  "metrics.depthSensors": "Mélységérzékelők",
  "metrics.dewPoint": "Harmatpont",
  "metrics.distance": "Távolság",
  "metrics.downTrend": "Csökkenő trend",
  "metrics.ET": "Evapotranszspiráció",
  "metrics.etToday": "ET ma",
  "metrics.feelsLike": "Hőérzet",
  "metrics.feelsLikeWithFormula": "Hőérzet ({formula})",
  "metrics.frostPoint": "Dérpont",
  "metrics.gust": "Széllökés",
  "metrics.gustDirection": "Széllökés iránya",
  "metrics.hail": "Jégeső",
  "metrics.heatIndex": "Hőindex",
  "metrics.heatingDegreeDays": "Fűtési fokos napok",
  "metrics.heatingPower": "Fűtőteljesítmény",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Páratartalom",
  "metrics.lastLightningImpact": "Utolsó villámcsapás",
  "metrics.lastMeasure": "Utolsó mérés",
  "metrics.leafSensors": "Levélérzékelők",
  "metrics.leafWetness": "A levél nedvessége",
  "metrics.lightningDistance": "Távolság",
  "metrics.lightningStrikeCount": "A villámcsapások száma",
  "metrics.lightningStrikeDistance": "Villámcsapás távolsága",
  "metrics.max": "Max.",
  "metrics.max_gust": "Max. széllökés",
  "metrics.maxToday": "Max. ma",
  "metrics.min": "Min.",
  "metrics.noise": "Zaj",
  "metrics.normalizedHeatingCoefficient": "Normalizált fűtési együttható",
  "metrics.outdoorTemperature": "Kültéri hőmérséklet",
  "metrics.PM_1": "PM 1",
  "metrics.PM_10": "PM 10",
  "metrics.PM_2P5": "PM 2.5",
  "metrics.precipitation": "Csapadék",
  "metrics.pressure": "Légnyomás",
  "metrics.rain": "Csapadék",
  "metrics.rainDurationValue": "Eső időtartama: {duration}",
  "metrics.rainfallMeasurement": "Csapadékmérés",
  "metrics.rainRate": "Eső intenzitása",
  "metrics.relativePressure": "Relatív nyomás",
  "metrics.setPoint": "Célérték",
  "metrics.snow": "Hó",
  "metrics.snowfall": "Havazás",
  "metrics.soilMoisture": "Talajnedvesség",
  "metrics.soilSensors": "Talajérzékelők",
  "metrics.soilWaterTension": "Talaj vízfeszültsége",
  "metrics.solarEnergy": "Napenergia",
  "metrics.solarRadiation": "Napsugárzás",
  "metrics.speed": "Sebesség",
  "metrics.stableTrend": "Stabil trend",
  "metrics.sum": "Összeg",
  "metrics.temperature": "Hőmérséklet",
  "metrics.temperatureSensors": "Hőmérséklet/nedvesség érzékelők",
  "metrics.temperatureShort": "Hőm.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "Emelkedés",
  "metrics.uv": "UV",
  "metrics.visibility": "Láthatóság",
  "metrics.weatherCondition": "Időjárási állapot",
  "metrics.wetBulbGlobeTemperature": "Nedves gömb hőm.",
  "metrics.wetBulbTemperature": "Nedves hőmérséklet",
  "metrics.wind": "Szél",
  "metrics.windChill": "Szélhűtés",
  "metrics.windDirection": "Szélirány",
  "metrics.windMeasurement": "Szélmérés",
  "metrics.windRun": "Szélút",
  "metrics.windRunDescription": "A szélút a szél által egy adott időszak alatt megtett teljes távolság",
  "metrics.windSpeed": "Szélsebesség",
  "navigation.allFavorites": "Összes megtekintése",
  "navigation.breadcrumbs": "Morzsamenü",
  "navigation.collapseNavigation": "Navigáció összecsukása",
  "navigation.expandNavigation": "Navigáció kibontása",
  "navigation.main": "Főmenü",
  "navigation.mapShort": "Térkép",
  "navigation.skipToContent": "Ugrás a fő tartalomhoz",
  "navigation.stationsShort": "Állomások",
  "network.cancelError": "Kérés visszavonva",
  "network.connectionError": "Szerver nem elérhető",
  "network.networkError": "Hálózat nem elérhető",
  "network.serverError": "Valami hiba történt...",
  "network.timeoutError": "Kapcsolat időtúllépés",
  "network.unknownError": "Ismeretlen hiba",
  "premium.alreadyPremium": "Már van prémium előfizetése!",
  "premium.bestValue": "Legjobb ár-érték",
  "premium.billingDetailsAndroid": "Ingyenes próbaidőszak: nem számítunk fel díjat, ha legalább 24 órával a próbaidőszak vége előtt lemondja. Ezután SmartMixin-előfizetése automatikusan megújul, hacsak le nem mondja legalább 24 órával az aktuális időszak vége előtt; bármikor lemondhatja a Google Play-fiókja beállításaiban. Minden megújítás a fenti gombon látható áron kerül felszámításra. A fizetés a vásárlás megerősítésekor és minden megújítási időszak kezdetén a Google Play-fiókját terheli.",
  "premium.billingDetailsIos": "Ingyenes próbaidőszak: nem számítunk fel díjat, ha legalább 24 órával a próbaidőszak vége előtt lemondja. Ezután SmartMixin-előfizetése automatikusan megújul, hacsak le nem mondja legalább 24 órával az aktuális időszak vége előtt; bármikor lemondhatja az App Store-fiókja beállításaiban. Minden megújítás a fenti gombon látható áron kerül felszámításra. A fizetés a vásárlás megerősítésekor és minden megújítási időszak kezdetén az App Store-fiókját terheli.",
  "premium.freeBannerBody": "Az ingyenes fiókok mindenhol GFS-t kapnak — az előnyben részesített modelljei és a „mindenhol máshol” attól a pillanattól működnek, hogy előfizet.",
  "premium.freeBannerTitle": "A beállítások Premiummal érvényesek",
  "premium.freeSubscription": "Ingyenes előfizetés",
  "premium.freeTrialForPeriod": "Ingyenes próbaidőszak {period, plural, one {# napig} other {# napig}}",
  "premium.getUnlimitedAccess": "Korlátlan hozzáférés:",
  "premium.manageMySubscription": "Előfizetésem kezelése",
  "premium.notPurchasedYet": "Ehhez az áruházi fiókhoz nem található SmartMixin Premium-vásárlás.",
  "premium.orChooseMonthly": "Vagy válasszon havi előfizetést:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Aktív",
  "premium.premiumAnnualTrialInfo": "Kezdje {days, plural, one {# napos} other {# napos}} ingyenes próbaidőszakkal",
  "premium.premiumCurrentPlan": "Jelenlegi csomag",
  "premium.premiumDownloadApp": "Az előfizetéshez töltse le az alkalmazást:",
  "premium.premiumEndsOn": "Lejár: {date}",
  "premium.premiumFeatureAlerts": "Időjárási riasztások",
  "premium.premiumFeatureAnalysis": "Fejlett időjárás-elemzés",
  "premium.premiumFeatureCharts": "Grafikonok összehasonlítása",
  "premium.premiumFeatureExport": "Adatexportálás",
  "premium.premiumFeatureForecast": "Regionális előrejelzési modellek",
  "premium.premiumFeatureNotification": "Állapotsor widget",
  "premium.premiumFeatureTitle": "Premium funkció",
  "premium.premiumFeatureWidgets": "Kezdőképernyő widgetek",
  "premium.premiumFreePlan": "Ingyenes",
  "premium.premiumInactive": "Nincs előfizetés",
  "premium.premiumManageStoreSubscription": "Előfizetését itt vásárolta: {store}. Ott kezelheti vagy mondhatja le.",
  "premium.premiumManageWebSubscription": "Kezelje előfizetését, frissítse a fizetési módot vagy mondja le.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Megújul: {date}",
  "premium.premiumSubscribeAnnual": "Éves — 9,99 €/év",
  "premium.premiumSubscribedOn": "Előfizetve itt: {platform}",
  "premium.premiumSubscribedOnWeb": "Előfizetve a weben",
  "premium.premiumSubscribeMonthly": "Havi — 1,99 €/hónap",
  "premium.premiumSubscribeOnWeb": "Fizessen elő most az összes prémium funkció feloldásához.",
  "premium.premiumSubscriptionSuccess": "Az előfizetése aktiválva lett! Élvezze az összes prémium funkciót.",
  "premium.premiumSubscriptionSuccessTitle": "Üdvözöljük a Premiumban!",
  "premium.premiumWebappNotice": "Az előfizetés a weben jelenleg nem érhető el.",
  "premium.pricePerMonth": "{price}/hónap",
  "premium.pricePerYear": "{price}/év",
  "premium.purchasedNetatmoPro": "Ön korábban megvásárolta a Netatmo Pro csomagot ({date}). Ez a prémium funkciók egy részéhez biztosít hozzáférést. Ha az összes prémium funkcióhoz hozzá szeretne férni, fizessen elő az alábbi ajánlatok egyikére.",
  "premium.purchaseFailed": "A vásárlást nem sikerült befejezni. Kérjük, próbálja újra.",
  "premium.restoreFailed": "A vásárlásait nem sikerült visszaállítani. Kérjük, próbálja újra.",
  "premium.restorePurchase": "Vásárlás visszaállítása",
  "premium.savingsPercent": "Megtakarítás {percent}%",
  "premium.seePremium": "Premium megtekintése",
  "premium.startFreeTrial": "Ingyenes próba indítása",
  "premium.storeUnavailable": "Az áruház jelenleg nem érhető el. Kérjük, próbálja újra később.",
  "premium.subscribeNow": "Feliratkozás most — próbaidő nélkül",
  "premium.switchToPremium": "Váltson SmartMixin Premiumra",
  "premium.thenPrice": "majd {price}",
  "providerHints.ambientWeatherApiKey": "Az ambientweather.net fiókbeállításaiban hozható létre.",
  "providerHints.davisApiSecret": "Csak egyszer látható a V2 API-kulcs létrehozásakor — őrizze meg biztonságosan.",
  "providerHints.davisV2ApiKey": "A weatherlink.com V2 API-kulcsok oldaláról.",
  "providerHints.ecowittApi": "Az Ecowitt fiók API-oldaláról.",
  "providerHints.ecowittApp": "Az alkalmazáskulcs, szintén az Ecowitt fiókjából.",
  "providerHints.myAcuriteCredentialsBanner": "Használja a My AcuRite-fiók e-mailjét és jelszavát — ne a SmartMixin-bejelentkezést.",
  "providerHints.myAcuriteEmail": "A My AcuRite-fiók e-mail címe — nem a SmartMixin-bejelentkezés.",
  "providerHints.myAcuritePassword": "A My AcuRite-fiók jelszava.",
  "providerHints.weatherflowToken": "Személyes token a tempestwx.com → beállítások → adatengedélyek menüpontból.",
  "providerHints.wundergroundEditKey": "Másik kulcs használata",
  "providerHints.wundergroundKey": "Egy hosszú karakterlánc a Weather Underground fiókjának API-kulcs oldaláról — nem a wunderground.com jelszava.",
  "providerHints.wundergroundKeyExample": "pl. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-kulcs ellenőrizve",
  "providerHints.wundergroundNoStationsNearby": "Nem található állomás a hely közelében. Próbálja meg közvetlenül megadni egy állomás azonosítóját.",
  "providerHints.wundergroundStationIdExample": "pl. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Szerezze be Ambient Weather API-kulcsát.",
  "providerIntro.davisStep2": "Szerezze be Davis V2 API-kulcsát és API-titkát.",
  "providerIntro.ecowittStep2": "Szerezze be Ecowitt API-kulcsát és alkalmazáskulcsát.",
  "providerIntro.getStarted": "Kezdje el",
  "providerIntro.myAcuriteStep2": "Használja meglévő My AcuRite-fiókja e-mailjét és jelszavát.",
  "providerIntro.netatmoEnergyStep2": "Jelentkezzen be a Netatmóba, amikor a rendszer kéri — nincs szükség API-kulcsra.",
  "providerIntro.netatmoWeatherStep2": "Jelentkezzen be a Netatmóba, amikor a rendszer kéri — nincs szükség API-kulcsra.",
  "providerIntro.signupBanner": "Majdnem kész — hozzon létre egy ingyenes SmartMixin-fiókot a {provider} csatlakoztatásához.",
  "providerIntro.step1": "Jelentkezzen be a SmartMixin-fiókjába (NEM a {provider}-be).",
  "providerIntro.step3EmailPassword": "Adja meg itt.",
  "providerIntro.step3KeyOrToken": "Illessze be ide.",
  "providerIntro.step3OAuth": "Engedélyezze a SmartMixint a felugró ablakban.",
  "providerIntro.step3Wunderground": "Illessze be az API-kulcsát, majd válasszon egy közeli állomást, vagy adja meg bármely állomás azonosítóját.",
  "providerIntro.stepOfTotal": "{step}. lépés / {total}",
  "providerIntro.title": "{provider} csatlakoztatása",
  "providerIntro.weatherflowStep2": "Szerezze be személyes Tempest tokenjét.",
  "providerIntro.wundergroundBrowsePublic": "Nincs állomása? Tallózzon a nyilvánosak között",
  "providerIntro.wundergroundFindNearby": "Közeli állomások keresése",
  "providerIntro.wundergroundOrEnterId": "Vagy adja meg egy állomás azonosítóját",
  "providerIntro.wundergroundStep2": "Szerezze be Weather Underground API-kulcsát. Ezt követően bármilyen állomást csatlakoztathat — sajátot vagy nyilvánosat.",
  "reports.agroMeteorology": "Agrometeorológia",
  "reports.analysis": "Elemzés",
  "reports.annualCumulativeRainfallComparison": "Az éves csapadékösszeg összehasonlítása",
  "reports.annualHeatingDurationComparison": "A fűtési idő éves összehasonlítása",
  "reports.annualHeatingEfficiency": "Éves termikus hatásfok",
  "reports.annualIndoorComparison": "Éves beltéri összevetés",
  "reports.annualOutdoorComparison": "Éves kültéri összevetés",
  "reports.annualOutdoorReport": "Éves kültéri jelentés",
  "reports.annualReport": "Éves jelentés",
  "reports.annualSolarReport": "Éves napsugárzási jelentés",
  "reports.annualWaterBalance": "Éves vízmérleg",
  "reports.annualWaterBalanceCarryOver": "Átvitel: {year} ({value})",
  "reports.annualWaterBalanceDescription": "A vízháztartás (egyszerűsített változat, csak eső és evapotranszspiráció használatos) lehetővé teszi a vízkészlet kezelését",
  "reports.avgHumidity": "Átlagos páratartalom",
  "reports.avgMaxTemperature": "Átlagos T°max",
  "reports.avgMetric": "Átlagos {metric}",
  "reports.avgMinTemperature": "Átlagos T°min",
  "reports.avgPressure": "Légnyomás átlag",
  "reports.avgTemperature": "Középhőmérséklet",
  "reports.chartsAndTable": "Diagramok és táblázat",
  "reports.climateNormalPeriodOfRecord": "Mérési időszak ({years} év)",
  "reports.climateNormals": "Éghajlati normálértékek",
  "reports.climateNormalStandardLabel": "Standard normálérték ({period})",
  "reports.climateTrendPerDecade": "Hőmérsékleti trend: {value}/évtized ({years} év alatt)",
  "reports.coldestMonthRanking": "A valaha mért leghidegebb {month}",
  "reports.comfortable": "Komfortos (45% {lessThan} Páratartalom ≤ 60%)",
  "reports.cumulativeRainfall": "Csapadékösszeg",
  "reports.cumulativeRainfallDescription": "Kövesse a kiválasztott időszak alatt felhalmozódó teljes csapadékmennyiséget.",
  "reports.dailyMaxRainfall": "Napi csapadék maximum",
  "reports.dataExport": "Adatok exportálása",
  "reports.dataExportXlsxFormatDescription": "Az állomás összes adatának mentése Excel formátumba (* .xlsx). Miután a gombra kattint, néhány perc múlva kap egy emailt a feldolgozott adatokkal.",
  "reports.daysOfData": "{days} napnyi adat",
  "reports.daysWithFrost": "Fagyos napok",
  "reports.daysWithHeavyRain": "Nagy csapadékú napok (≥ {threshold})",
  "reports.daysWithoutThaw": "Napok fagypont alatti maximummal",
  "reports.daysWithStrongFrost": "Erősen fagyos napok",
  "reports.emailSent": "E-mail címedre elküldtük az adatokat",
  "reports.frostDays": "Fagyos napok száma",
  "reports.grasslandTemperatureSum": "A gyephőmérséklet összege",
  "reports.grasslandTemperatureSumDescription": "A növényzet fenntartható helyreállítása, ha az összeg eléri a {threshold}",
  "reports.growingDegreeDays": "Növekedési foknapok",
  "reports.highPressure": "Magas légnyomás (≥ {threshold})",
  "reports.iceDays": "Téli napok",
  "reports.indoorReport": "Beltéri jelentés",
  "reports.keyFacts": "Statisztika",
  "reports.longestDrySpell": "Leghosszabb száraz időszak",
  "reports.longestRunOfRainyDays": "Az egymást követő esős napok száma",
  "reports.longestRunWithoutRun": "Az egymást követő napok száma eső nélkül",
  "reports.longestWetSpell": "Leghosszabb csapadékos időszak",
  "reports.lowPressure": "Alacsony légnyomás ({lessThan} {threshold})",
  "reports.maxHumidity": "Maximum páratartalom",
  "reports.maxMetric": "Maximális {metric}",
  "reports.maxPressure": "Maximum légnyomás",
  "reports.maxTemperature": "Hőmérsékleti maximum",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maximum eltérés (/24H)",
  "reports.minHumidity": "Minimum páratartalom",
  "reports.minMetric": "Minimális {metric}",
  "reports.minPressure": "Minimum légnyomás",
  "reports.minTemperature": "Hőmérsékleti minimum",
  "reports.minTempMagnitude24h": "Minimum eltérés (/24H)",
  "reports.monthlyAverageCountdown": "Még {days} nap ebben a hónapban",
  "reports.monthlyAverageCountdownDetail": "Ekkor megjelenik a havi átlag és a helyezése.",
  "reports.monthlyAverageRule": "A havi átlagok és helyezések akkor jelennek meg, ha egy naptári hónapban {days} nap van rögzítve.",
  "reports.monthlyHeatingEfficiency": "Havi termikus hatásfok",
  "reports.monthlyOutdoorReport": "Havi kültéri jelentés",
  "reports.monthlyReport": "Havi jelentés",
  "reports.monthlySolarReport": "Havi napsugárzási jelentés",
  "reports.monthlyWindReport": "Havi széljelentés",
  "reports.monthsOfData": "{months} hónapnyi adat",
  "reports.numberOfDays": "Napok száma",
  "reports.onThisDayChartRule": "Az évenkénti grafikon akkor jelenik meg, ha {date} napra {count} év adata rögzítve van.",
  "reports.onThisDayChartSummary": "{years, plural, one {# év} other {# év}} hőmérséklettel, {first}–{last}. Melegrekord {high} ({highYears}), hidegrekord {low} ({lowYear}). Normál nap {min} – {max}.",
  "reports.onThisDayCoverage": "{years} év {firstYear} óta",
  "reports.onThisDayDataSince": "Ennek az állomásnak {date} óta vannak adatai.",
  "reports.onThisDayEveryYear": "Minden {date} az archívumban",
  "reports.onThisDayGapNoData": "nincs adat",
  "reports.onThisDayInHistory": "Ezen a napon a történelemben",
  "reports.onThisDayLeaveOk": "Elhagyhatja ezt a képernyőt; a betöltés folytatódik.",
  "reports.onThisDayLoadFailed": "Nem sikerült betölteni: {date}. Ellenőrizze a kapcsolatot, és próbálja újra.",
  "reports.onThisDayNoDataRun": "{start}–{end} · nincs adat ({count} év)",
  "reports.onThisDayNormal": "Normál nap: {min} – {max}",
  "reports.onThisDayNoYears": "Még nincs teljes adat erre a napra: {date}",
  "reports.onThisDayNoYearsDetail": "Ez az oldal az első olyan {date} naptól töltődik fel, amelyet az állomás teljesen rögzít.",
  "reports.onThisDayNoYearSelected": "Nincs kiválasztott év",
  "reports.onThisDayOneReading": "1 mérés",
  "reports.onThisDayOneReadingSummary": "{year}: {value}, 1 mérés, csapadék {rain}",
  "reports.onThisDayOpenRecords": "Rekordok és éghajlat megnyitása",
  "reports.onThisDayPickHint": "Módosítja a megjelenített napot",
  "reports.onThisDayPickTitle": "Válasszon napot",
  "reports.onThisDayRain": "Csapadék: {date}",
  "reports.onThisDayRainNotMeasured": "nincs mérve",
  "reports.onThisDayRainOnlySummary": "{year}: csapadék {rain}",
  "reports.onThisDayRainSince": "csapadék {year} óta",
  "reports.onThisDayRainSummary": "Csapadék: {date}. Legcsapadékosabb nap {value} ({years}).",
  "reports.onThisDayRetry": "Próbálja újra",
  "reports.onThisDaySingleReading": "{count} évben csak egy mérés van aznapra, ezek nincsenek ábrázolva.",
  "reports.onThisDaySlowLoad": "{years} év adatainak beolvasása ({date}). Egy dátum első megnyitása akár 20 másodpercig is tarthat.",
  "reports.onThisDaySlowLoadGeneric": "Az állomás előzményeinek beolvasása ({date}). Egy dátum első megnyitása akár 20 másodpercig is tarthat.",
  "reports.onThisDayTied": "holtversenyben: {years}",
  "reports.onThisDayTiedMore": "holtversenyben: {years} +{count}",
  "reports.onThisDayYearSummary": "{year}: minimum {min}, maximum {max}, csapadék {rain}",
  "reports.onThisDayYearTied": "{year} ({tied})",
  "reports.outdoorReport": "Kültéri jelentés",
  "reports.overviewSection": "Áttekintés",
  "reports.rainfall": "Csapadék",
  "reports.rainyDays": "Csapadékos napok",
  "reports.recordClimatologicalDay": "Klimatológiai nap (06–06 UTC)",
  "reports.recordClimDayBody": "A csapadékot itt naptári naponként összegezzük, éjféltől éjfélig az állomás helyi ideje szerint. Az időjárási szolgálatok 06:00 és 06:00 UTC között összegzik, így egy éjfél körüli vihar miatt egy másik nap lehet a legcsapadékosabb.",
  "reports.recordDailyRain": "Legcsapadékosabb nap",
  "reports.recordFromHourlyReadings": "Óránkénti mérésekből",
  "reports.recordHigh": "Melegrekord",
  "reports.recordLow": "Hidegrekord",
  "reports.recordOfficialBody": "Az időjárási szolgálat napi maximumot és minimumot tesz közzé erről az állomásról, maximum- és minimumhőmérőről leolvasva. Ezek elkapják azokat a rövid csúcsokat, amelyeket az óránkénti mérések elmulasztanak, ezért felváltják az óránkénti mérésekből számított értékeket.",
  "reports.recordOfficialValue": "Hivatalos érték",
  "reports.recordsAndClimatology": "Rekordok és éghajlat",
  "reports.recordSheetTitle": "Ezekről a rekordokról",
  "reports.recordsSince": "Rekordok {date} óta",
  "reports.recordWindGust": "Legerősebb széllökés",
  "reports.relativelyWet": "Viszonylag magas (60% {lessThan} Páratartalom ≤ 80%)",
  "reports.sectionReportCount": "{count} jelentés",
  "reports.sendEmail": "E-mail küldése",
  "reports.summerDays": "Nyári napok",
  "reports.tableScrollRegion": "{title}, vízszintesen görgethető",
  "reports.tooDry": "Nagyon alacsony (Páratartalom ≤ 45%)",
  "reports.tooWet": "Nagyon magas (Páratartalom {greaterThan} 80%)",
  "reports.tropicalNights": "Trópusi éjszakák",
  "reports.unlockPremiumSubtitle": "A SmartMixin Premium része",
  "reports.unlockPremiumTitle": "{count} prémium funkció feloldása",
  "reports.warmestMonthRanking": "A valaha mért legmelegebb {month}",
  "reports.waterBalance": "Vízmérleg",
  "reports.yearsOfData": "{years} évnyi adat",
  "reports.yearToDateTemperatureComparison": "Hőmérséklet-összehasonlítás az év elejétől",
  "sensors.bgtSensors": "Fekete gömb & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareHumidity": "Páratartalom összehasonlítása",
  "sensors.compareMoisture": "Talajnedvesség összehasonlítása",
  "sensors.comparePm25": "PM2.5 összehasonlítása",
  "sensors.compareTemperatures": "Hőmérsékletek összehasonlítása",
  "sensors.compareWaterTension": "Talaj vízfeszültségének összehasonlítása",
  "sensors.depthByChannel": "Mélység csatornánként",
  "sensors.heatStressExtreme": "Extrém hőstressz",
  "sensors.heatStressModerate": "Mérsékelt hőstressz",
  "sensors.heatStressNone": "Nincs hőstressz",
  "sensors.heatStressStrong": "Erős hőstressz",
  "sensors.heatStressVeryStrong": "Nagyon erős hőstressz",
  "sensors.indoorClimate": "Beltéri klíma",
  "sensors.indoorCo2Levels": "CO2-szintek",
  "sensors.indoorTemperatureAndHumidity": "Hőmérséklet és páratartalom",
  "sensors.leafWetnessByChannel": "Levélnedvesség csatornánként",
  "sensors.lightningSensor": "Villám",
  "sensors.moistureByChannel": "Talajnedvesség csatornánként",
  "sensors.noDataAvailable": "Nem áll rendelkezésre adat",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 csatornánként",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Csatorna kiválasztása",
  "sensors.sensorDetailDescription": "Tekintse meg a szenzorcsatornák előzményadatait és trendjeit.",
  "sensors.sensorHistory": "Szenzor előzmények",
  "sensors.soilConductivityByChannel": "Vezetőképesség csatornánként",
  "sensors.soilTemperatureByChannel": "Talajhőmérséklet csatornánként",
  "sensors.strikesToday": "Becsapódások ma",
  "sensors.temperatureByChannel": "Hőmérséklet csatornánként",
  "sensors.viewChart": "Diagram megtekintése",
  "sensors.waterTensionByChannel": "Talaj vízfeszültsége csatornánként",
  "settings.appearance": "Megjelenés",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arab",
  "settings.bulgarian": "bolgár",
  "settings.catalan": "katalán",
  "settings.chartGestures": "Gesztusok a diagramokon",
  "settings.chartGesturesDescription": "A diagramon húzva módosíthatja az időszakot, a diagram csippentésével az időskálát változtathatja meg",
  "settings.choiceCount": "{count, plural, one {# elérhető} other {# elérhető}}",
  "settings.contactUs": "Kapcsolat",
  "settings.contactUsDescription": "Segítség vagy visszajelzés küldése",
  "settings.croatian": "horvát",
  "settings.czech": "cseh",
  "settings.dailyDetailByPeriods": "Napi részletek napszakok szerint",
  "settings.dailyDetailByPeriodsDescription": "A 24 óra csoportosítása éjszakára, reggelre, délutánra és estére — ugyanaz a felosztás, amit a napi összefoglaló használ.",
  "settings.danish": "dán",
  "settings.dark": "Sötét téma",
  "settings.dataDisplay": "Adatmegjelenítés",
  "settings.dateAndTime": "Dátum és idő",
  "settings.donateButton": "Adományozás",
  "settings.donateDescription": "A SmartMixint egy kis csapat fejleszti. Ha hasznosnak találja, egyszeri, tetszőleges összegű adománnyal támogathatja a fejlesztését. Ez egy ajándék — nem módosítja a csomagját, és nem old fel semmilyen funkciót.",
  "settings.donateSuccessBody": "Az adománya segít, hogy a SmartMixin működjön és folyamatosan fejlődjön. Nagyon hálásak vagyunk érte.",
  "settings.donateSuccessTitle": "Köszönjük a támogatását!",
  "settings.donateTitle": "Támogassa a SmartMixint",
  "settings.dragToReorder": "Húzza az átrendezéshez",
  "settings.dutch": "holland",
  "settings.english": "angol",
  "settings.french": "francia",
  "settings.german": "német",
  "settings.gestures": "Gesztusok",
  "settings.greek": "görög",
  "settings.hungarian": "magyar",
  "settings.italian": "olasz",
  "settings.japanese": "japán",
  "settings.korean": "koreai",
  "settings.language": "Nyelv",
  "settings.languageDescription": "Preferált nyelv",
  "settings.light": "Világos téma",
  "settings.mapTheme": "Térkép témája",
  "settings.mapThemeAuto": "Auto",
  "settings.mapThemeDark": "Sötét",
  "settings.mapThemeDescription": "Auto beállítással a térkép az alkalmazás témáját követi.",
  "settings.mapThemeLight": "Világos",
  "settings.measurementUnits": "Mértékegységek",
  "settings.netatmoDashboard": "Netatmo áttekintés",
  "settings.netatmoLayoutCards": "Kártyalista",
  "settings.netatmoLayoutCardsDescription": "Modulonként egy kártya, egyetlen görgetésben",
  "settings.netatmoLayoutClassic": "Klasszikus",
  "settings.netatmoLayoutClassicDescription": "Két kártya, lapozás a modulok között",
  "settings.netatmoNewLayoutNotice": "Új elrendezés: modulonként egy kártya.",
  "settings.netatmoSwitchBackToClassic": "Vissza a klasszikusra",
  "settings.netatmoSwitchToLayout": "Váltás erre: {layout}",
  "settings.norwegian": "norvég",
  "settings.notificationsSection": "Értesítések",
  "settings.ongoingNotificationEnabled": "Állandó értesítés engedélyezése",
  "settings.ongoingNotificationMetrics": "Megjelenített mérőszámok",
  "settings.ongoingNotificationPermissionRequired": "Értesítési engedély szükséges",
  "settings.ongoingNotificationPreviewHint": "Előnézet — kapcsolja be a widgetet a megjelenítéshez",
  "settings.ongoingNotificationStatusBar": "Állapotsor",
  "settings.polish": "lengyel",
  "settings.portuguese": "portugál",
  "settings.preferencesSection": "Preferenciák",
  "settings.privacyPolicy": "Adatvédelmi irányelvek",
  "settings.russian": "orosz",
  "settings.serbian": "szerb",
  "settings.settings": "Beállítások",
  "settings.settingsPageTitle": "Beállítások - {page}",
  "settings.slovak": "szlovák",
  "settings.smallDecimals": "Kis tizedesjegyek",
  "settings.smallDecimalsDescription": "Tizedesjegyek kisebb méretben történő megjelenítése",
  "settings.spanish": "spanyol",
  "settings.statusBarWidget": "Állapotsor widget",
  "settings.statusBarWidgetDescription": "Mindig látható időjárási adatok",
  "settings.subscriptionSection": "Előfizetés",
  "settings.supportSection": "Támogatás",
  "settings.swedish": "svéd",
  "settings.systemTheme": "Rendszer szerinti",
  "settings.termsOfService": "Szolgáltatási feltételek",
  "settings.themeDarkShort": "Sötét",
  "settings.themeLightShort": "Világos",
  "settings.themeSystemShort": "Rendszer",
  "settings.turkish": "török",
  "settings.ukrainian": "ukrán",
  "settings.units": "Mértékegységek",
  "settings.unitsDescription": "Az alkalmazásban használatos mértékegységek",
  "settings.update": "Frissítés",
  "settings.windDirectionConvention": "Szélirány nyíl",
  "settings.windDirectionConventionDescription": "Válassza ki a szélirány nyilak megjelenítési módját",
  "settings.windDirectionMeteorological": "Eredet iránya",
  "settings.windDirectionMeteorologicalDescription": "A nyíl azt mutatja, honnan fúj a szél (meteorológiai konvenció)",
  "settings.windDirectionOceanographic": "Áramlási irány",
  "settings.windDirectionOceanographicDescription": "A nyíl azt mutatja, merre fúj a szél (oceanográfiai konvenció)",
  "stations.addAStation": "Állomás hozzáadása",
  "stations.addToFavorites": "Hozzáadás a kedvencekhez",
  "stations.addYourOwnStation": "Adja hozzá az állomását",
  "stations.clearRecentLocations": "Összes törlése",
  "stations.clearSearch": "Keresés törlése",
  "stations.currentLocation": "Aktuális hely",
  "stations.customizedStationName": "Egyéni állomásnév",
  "stations.favoriteLocations": "Kedvencek",
  "stations.favoriteLocationsEmpty": "Legfeljebb 5 kedvenc helyet adhat hozzá.",
  "stations.favoriteStations": "Kedvenc állomások",
  "stations.filterStationDescription": "Megbízhatatlan mérésű állomások elrejtése",
  "stations.filterStations": "Állomások szűrése",
  "stations.filterStationSourceDescription": "Válassza ki azokat az állomásszolgáltatókat, amelyeket meg szeretne jeleníteni a térképen",
  "stations.findStationsNearYou": "Állomások keresése a közelben",
  "stations.hiddenStations": "Rejtett állomások",
  "stations.hiddenStationsDescription": "Egy állomás elrejtését a mellette lévő szem ikonra koppintva szüntetheti meg.",
  "stations.hideStationNamed": "{station} elrejtése",
  "stations.lastSeen": "utoljára {time}",
  "stations.loadingStation": "Állomás betöltése…",
  "stations.location": "Hely",
  "stations.locationAddedToFavorites": "Helyszín hozzáadva a kedvencekhez",
  "stations.locationNotGranted": "A helymeghatározási engedély nincs megadva. Engedélyezze a helyadatokhoz való hozzáférést az eszköz beállításaiban.",
  "stations.locationRemovedFromFavorites": "Hely eltávolítva a kedvencek közül",
  "stations.locations": "Helyek",
  "stations.locationUnavailable": "Nem sikerült meghatározni a tartózkodási helyét. Ellenőrizze az eszköz beállításait.",
  "stations.maxFavoriteLocationsReached": "Csak 5 kedvenc helye lehet. Távolítsa el az egyiket a másik hozzáadásához.",
  "stations.modifyFavoriteStations": "Módosítsa a kedvenc állomásait",
  "stations.modifyFavoriteStationsDescription": "Átrendezheti kedvenc állomásait azáltal, hogy húzza őket. A listáról is eltávolíthatja őket.",
  "stations.myLocation": "Saját hely",
  "stations.nearbyWeatherStations": "Közeli időjárási állomások",
  "stations.noLocationsFound": "Nem található hely",
  "stations.noLongerReported": "Már nem szerepel",
  "stations.noLongerReportedBy": "{provider}: {date} óta nem szerepel",
  "stations.noSearchResults": "Nincs a keresésnek megfelelő cikk",
  "stations.noStationsFound": "Nem található állomás",
  "stations.noWeatherStationYet": "Jelenleg nem kapcsolódik egyetlen időjárás állomáshoz sem.",
  "stations.recentLocations": "Legutóbbiak",
  "stations.recentLocationsEmpty": "Nincsenek előzmények.",
  "stations.removeFromFavorites": "Törlés a kedvencek közül",
  "stations.removeStationNamed": "{station} törlése a kedvencek közül",
  "stations.reorderStationNamed": "{station} áthelyezése",
  "stations.searchForLocation": "Hely keresése",
  "stations.searchForWeatherStation": "Keressen egy meteorológiai állomást",
  "stations.searchResults": "Keresési eredmények",
  "stations.searchResultsEmpty": "Nincs eredmény.",
  "stations.searchResultsFound": "{count, plural, one {# találat} other {# találat}}",
  "stations.searchStationsDescription": "Adjon meg egy várost, címet vagy helynevet a közeli időjárás-állomások megtalálásához.",
  "stations.searchStationsHint": "Használja a fenti keresősávot, hogy felfedezze az időjárás-állomásokat a világ bármely pontján.",
  "stations.selectStationForComparison": "Válassza ki az állomást az összehasonlításhoz",
  "stations.stationAddedToFavorites": "Az állomás hozzáadva a kedvencekhez",
  "stations.stationCount": "{count, plural, one {# állomás} other {# állomás}}",
  "stations.stationInformation": "Állomás adatok",
  "stations.stationName": "Állomás neve",
  "stations.stationObservationsDescription": "Megjeleníti az időjárási állomások legfrissebb megfigyelését",
  "stations.stationRemovedFromFavorites": "Az állomás eltávolítva a kedvencek közül",
  "stations.stationsLoading": "Meteorológiai állomások betöltése",
  "stations.stationsNear": "Állomások {place} közelében",
  "stations.stationType": "Állomás típusa",
  "stations.statusOffline": "Offline",
  "stations.statusOnline": "Online",
  "stations.statusStale": "Elavult",
  "stations.tryAnotherLocation": "Nem találtunk időjárás-állomásokat e hely közelében. Próbáljon meg egy másik területen keresni.",
  "stations.unhideStationNamed": "{station} újbóli megjelenítése",
  "stations.weatherStation": "Meteorológiai állomás",
  "stations.weatherStationCount": "{count, plural, one {# meteorológiai állomás} other {# meteorológiai állomás}}",
  "stations.weatherStations": "Meteorológiai állomások",
  "stations.welcomeConnectService": "Van időjárás-állomása? Csatlakoztassa a szolgáltatását",
  "stations.welcomeSubtitle": "Az időjárásod, minden egy helyen",
  "thermostat.away": "Távollét",
  "thermostat.boilerOn": "Kazán aktivitás",
  "thermostat.hg": "Fagyvédelem",
  "thermostat.homeInformation": "Otthoni információk",
  "thermostat.homeName": "Otthon neve",
  "thermostat.manualBoost": "Manuális szabályzás",
  "thermostat.manualSetpointUntil": "Manuális alapjel eddig:",
  "thermostat.noThermostatYet": "Jelenleg nem kapcsolódik egyetlen termosztáthoz sem.",
  "thermostat.relay": "Relé",
  "thermostat.room": "Szoba",
  "thermostat.rooms": "Szobák",
  "thermostat.smartThermostat": "Okos termosztát",
  "thermostat.smartValve": "Okos radiátorszelep",
  "thermostat.whenBackHome": "Mikor fog hazaérni?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Inch",
  "units.inchOfMercury": "Higanyhüvelyk",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Kilométer per óra",
  "units.knot": "Csomó",
  "units.meterPerSecond": "Méter per szekundum",
  "units.milePerHour": "Mérföld per óra",
  "units.millibar": "Millibar",
  "units.millimeter": "Milliméter",
  "units.millimeterOfMercury": "Higanymilliméter",
  "weatherConditions.blizzard": "Hóvihar",
  "weatherConditions.blowingDust": "Porfúvás",
  "weatherConditions.blowingSnow": "Hófúvás",
  "weatherConditions.breezy": "Enyhe szél",
  "weatherConditions.clear": "Derült",
  "weatherConditions.cloudy": "Borult",
  "weatherConditions.drizzle": "Szitálás",
  "weatherConditions.flurries": "Gyenge havazás",
  "weatherConditions.foggy": "Köd",
  "weatherConditions.freezingDrizzle": "Ónos szitálás",
  "weatherConditions.freezingRain": "Ónos eső",
  "weatherConditions.frigid": "Dermesztő hideg",
  "weatherConditions.hail": "Jégeső",
  "weatherConditions.haze": "Pára",
  "weatherConditions.heavyRain": "Erős eső",
  "weatherConditions.heavySnow": "Erős havazás",
  "weatherConditions.hot": "Hőség",
  "weatherConditions.hurricane": "Hurrikán",
  "weatherConditions.isolatedThunderstorms": "Elszigetelt zivatarok",
  "weatherConditions.mixedRainAndHail": "Eső és jégeső",
  "weatherConditions.mostlyClear": "Többnyire derült",
  "weatherConditions.mostlyCloudy": "Többnyire borult",
  "weatherConditions.mostlySunny": "Többnyire napos",
  "weatherConditions.notAvailable": "Az időjárási viszonyok nem érhetők el",
  "weatherConditions.partlyCloudy": "Részben felhős",
  "weatherConditions.rain": "Eső",
  "weatherConditions.rainSleet": "Eső és jégdara",
  "weatherConditions.rainSnow": "Havas eső",
  "weatherConditions.scatteredShowers": "Szórványos záporok",
  "weatherConditions.scatteredSnowShowers": "Szórványos hózáporok",
  "weatherConditions.scatteredThunderstorms": "Szórványos zivatarok",
  "weatherConditions.showers": "Záporok",
  "weatherConditions.sleet": "Jégdara",
  "weatherConditions.smoke": "Füst",
  "weatherConditions.snow": "Havazás",
  "weatherConditions.snowShowers": "Hózáporok",
  "weatherConditions.strongStorms": "Erős zivatarok",
  "weatherConditions.sunny": "Napos",
  "weatherConditions.thunderstorms": "Zivatarok",
  "weatherConditions.tornado": "Tornádó",
  "weatherConditions.tropicalStorm": "Trópusi vihar",
  "weatherConditions.windy": "Szeles",
  "weatherConditions.wintryMix": "Vegyes téli csapadék",
  "weatherMap.clusterMarkerName": "{metric} {value}, {count, plural, other {# állomás}} mediánja, nagyítás",
  "weatherMap.legendHeavy": "Erős",
  "weatherMap.legendLight": "Gyenge",
  "weatherMap.legendLightningHelp": "A szín az egyes villámok korát mutatja az elmúlt {minutes} percben — a legújabbak fehérrel, a legrégebbiek sötétvörössel.",
  "weatherMap.legendNewest": "Legújabb",
  "weatherMap.legendOldest": "Legrégebbi",
  "weatherMap.legendStationsHelp": "A jelölő színe a kiválasztott mérőszám értékét tükrözi.",
  "weatherMap.lightningDataAttribution": "Villámadatok: Blitzortung.org",
  "weatherMap.lightningStrikes": "Villámcsapások",
  "weatherMap.lightningStrikesDescription": "Villámcsapások megjelenítése valós időben a térképen",
  "weatherMap.mapLayers": "Térképrétegek",
  "weatherMap.mapLegend": "Térkép jelmagyarázat",
  "weatherMap.mapMode": "Térképmód",
  "weatherMap.mapNameForecast": "Előrejelzési térkép, {model}, {variable}",
  "weatherMap.mapNameObservations": "Meteorológiai térkép, észlelések",
  "weatherMap.modeForecast": "Előrejelzés",
  "weatherMap.modeObservations": "Észlelések",
  "weatherMap.radarDataAttribution": "Radaradatok: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.radarTime": "Radarkép időpontja",
  "weatherMap.rainRadar": "Esőradar",
  "weatherMap.rainRadarDescription": "Jelenítse meg az esőradar fedvényét a térképen",
  "weatherMap.resetBearing": "Húzza a térkép elforgatásához, kattintson az északi tájolás visszaállításához",
  "weatherMap.showingForecast": "Megjelenített előrejelzés: {model}, {variable}",
  "weatherMap.signInForecastBody": "A GFS-térképek ingyenesek egy SmartMixin-fiókkal. Premiummal további modellek is elérhetők.",
  "weatherMap.signInForecastTitle": "Jelentkezzen be az előrejelzési térképek megtekintéséhez",
  "weatherMap.stationMarkerName": "{metric} {value}, egy állomás",
  "weatherMap.stationMarkersHint": "A nyílbillentyűkkel lépkedhet az állomások között",
  "weatherMap.stationMarkerWindValue": "{speed}, {direction} felől",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "Az NC Rain egy további adatforrás, amelyet a Nearcast Technology által hajtott Tempest Weather System biztosít. Az NC Rain adatok a Tempest körüli átlagos csapadékmennyiség becslése a környék szintjén",
  "weatherMap.weatherMap": "Meteorológiai térkép",
  "weatherMap.weatherMapMetaDescription": "A SmartMixin interaktív időjárási és radaros térképeket kínál a világ minden tájáról.",
  "weatherMap.zoomIn": "Nagyítás",
  "weatherMap.zoomOut": "Kicsinyítés",
  "weatherWarnings.activeNow": "Most érvényes",
  "weatherWarnings.agencyMessage": "A meteorológiai szolgálat üzenete",
  "weatherWarnings.areaCovered": "Érintett terület",
  "weatherWarnings.areaThisLocation": "{area} (ez a hely)",
  "weatherWarnings.areaYourStation": "{area} (az Ön meteorológiai állomása)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Hivatalos figyelmeztetés, {severity}: {hazard}} one {Hivatalos figyelmeztetés, {severity}: {hazard}, és még #} other {Hivatalos figyelmeztetés, {severity}: {hazard}, és még #}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Közelgő hivatalos figyelmeztetés, {severity}: {hazard}} one {Közelgő hivatalos figyelmeztetés, {severity}: {hazard}, és még #} other {Közelgő hivatalos figyelmeztetés, {severity}: {hazard}, és még #}}",
  "weatherWarnings.crumb": "Hivatalos figyelmeztetések",
  "weatherWarnings.emptyBody": "Az országos meteorológiai szolgálatnak nincs érvényes figyelmeztetése erre a helyre. Néhány percenként újra ellenőrizzük.",
  "weatherWarnings.emptyTitle": "Nincs hivatalos figyelmeztetés",
  "weatherWarnings.ended": "Lejárt",
  "weatherWarnings.endedAt": "Ez a figyelmeztetés lejárt ekkor: {time}.",
  "weatherWarnings.errorBody": "Ellenőrizze a kapcsolatot. Néhány percenként újra próbálkozunk.",
  "weatherWarnings.errorTitle": "Nem sikerült betölteni a hivatalos figyelmeztetéseket",
  "weatherWarnings.fromTime": "Kezdés: {time}",
  "weatherWarnings.hazardAirQuality": "Levegő minősége",
  "weatherWarnings.hazardAvalanche": "Lavinák",
  "weatherWarnings.hazardCoastalEvent": "Parti veszélyek",
  "weatherWarnings.hazardFlood": "Árvíz",
  "weatherWarnings.hazardFog": "Köd",
  "weatherWarnings.hazardForestFire": "Erdőtüzek",
  "weatherWarnings.hazardHighTemperature": "Magas hőmérséklet",
  "weatherWarnings.hazardLowTemperature": "Alacsony hőmérséklet",
  "weatherWarnings.hazardOther": "Egyéb veszély",
  "weatherWarnings.hazardRain": "Eső",
  "weatherWarnings.hazardSnowIce": "Hó és jegesedés",
  "weatherWarnings.hazardThunderstorm": "Zivatarok",
  "weatherWarnings.hazardUv": "UV-sugárzás",
  "weatherWarnings.hazardWind": "Szél",
  "weatherWarnings.hideHazards": "Veszélyek elrejtése",
  "weatherWarnings.issuedBy": "Kiadta: {sender}",
  "weatherWarnings.lastUpdate": "Utolsó frissítés: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Az érintett terület térképe: {area}.} other {Az érintett területek térképe (#). Kiemelve: {area}.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Az érintett terület térképe.} other {Az érintett területek térképe (#).}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {A térkép nem érhető el. A terület lent látható.} other {A térkép nem érhető el. A területek listája (#) lent látható.}}",
  "weatherWarnings.moreHazards": "+ további {count}: {hazards}",
  "weatherWarnings.notInLanguage": "Nem érhető el ezen a nyelven: {language}. A meteorológiai szolgálat által közzétett formában látható.",
  "weatherWarnings.openOn": "Megnyitás itt: {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # további terület} other {+ # további terület}}",
  "weatherWarnings.severityExtreme": "Rendkívüli",
  "weatherWarnings.severityFrom": "{severity}, kezdés: {time}",
  "weatherWarnings.severityMinor": "Enyhe",
  "weatherWarnings.severityModerate": "Mérsékelt",
  "weatherWarnings.severityNow": "{severity} most",
  "weatherWarnings.severitySevere": "Súlyos",
  "weatherWarnings.severityUntil": "{severity}, eddig: {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {# terület megjelenítése} other {Összes terület megjelenítése (#)}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {# terület megjelenítése a térképen} other {Összes terület megjelenítése a térképen (#)}}",
  "weatherWarnings.showHazards": "Veszélyek megjelenítése",
  "weatherWarnings.showPeriods": "{count, plural, one {# időszak megjelenítése} other {Összes időszak megjelenítése (#)}}",
  "weatherWarnings.source": "Forrás: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, majd {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# hivatalos időjárási figyelmeztetés} other {# hivatalos időjárási figyelmeztetés}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Hivatalos időjárási figyelmeztetések",
  "weatherWarnings.todayAt": "ma {time}",
  "weatherWarnings.tomorrow": "Holnap",
  "weatherWarnings.tomorrowAt": "holnap {time}",
  "weatherWarnings.upcoming": "Közelgő",
  "weatherWarnings.viewAll": "Összes hivatalos figyelmeztetés",
  "weatherWarnings.whatToDo": "Teendők"
}
